// Menu.js - Version complète avec points cadeaux et QR Code (version corrigée)
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./Menu.css";
import { useSelector, useDispatch } from "react-redux";
import { deletePendingTable, getAllPendingTables } from "../Redux/Actions/pendingTableActions";

// ========================================
// IMPORT DU SYSTÈME DE PARAMÉTRAGE
// ========================================
import ConfigurationManager from './ConfigurationManager';

// ========================================
// IMPORT DU SCANNER QR CODE HTML5
// ========================================
import { Html5QrcodeScanner } from "html5-qrcode";

function Menu() {
  const currentUser = useSelector((state) => state.AuthReducer?.user);
  console.log("👤 Utilisateur connecté:", currentUser);

  // ========================================
  // CONFIGURATION DU PARAMÉTRAGE
  // ========================================
  const [config, setConfig] = useState(null);
  const [isFoodTrackMode, setIsFoodTrackMode] = useState(false);
  const [autoTableNumber, setAutoTableNumber] = useState("");

  // Initialiser la configuration
  useEffect(() => {
    const initializedConfig = ConfigurationManager.init();
    setConfig(initializedConfig.config);

    // Vérifier si on est en mode foodtrack (sans tables)
    const foodTrackMode = !initializedConfig.config.restaurant.hasTables ||
      initializedConfig.config.restaurant.type === 'foodtrack';
    setIsFoodTrackMode(foodTrackMode);

    // Générer un numéro de table automatique pour foodtrack
    if (foodTrackMode) {
      const autoTable = initializedConfig.generateAutoTableNumber();
      setAutoTableNumber(autoTable);
      setTableNumber(autoTable); // Définir automatiquement la table
    }

    console.log("🎯 Mode:", foodTrackMode ? "FOODTRACK" : "RESTAURANT");
    console.log("📋 Configuration chargée:", initializedConfig.config);
  }, []);

  // États principaux
  const [menuData, setMenuData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [additionItems, setAdditionItems] = useState([]);
  const [discountCardNumber, setDiscountCardNumber] = useState("");
  const [tableNumber, setTableNumber] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [loading, setLoading] = useState(false);

  // États pour les popups
  const [showTablesPopup, setShowTablesPopup] = useState(false);
  const [showPartialPayment, setShowPartialPayment] = useState(false);
  const [selectedPartialItems, setSelectedPartialItems] = useState([]);
  const [partialQuantities, setPartialQuantities] = useState({});
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferTargetTable, setTransferTargetTable] = useState("");
  const [tableToTransfer, setTableToTransfer] = useState(null);
  const [showTableSelectionPopup, setShowTableSelectionPopup] = useState(false);
  const [showPrintAddition, setShowPrintAddition] = useState(false);

  // État pour le popup de paiement
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  // États pour l'addition personnel
  const [showStaffModal, setShowStaffModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [isStaffAddition, setIsStaffAddition] = useState(false);

  // States pour l'annulation
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [adminCode, setAdminCode] = useState("");
  const [cancelBarcodeInput, setCancelBarcodeInput] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [billsHistory, setBillsHistory] = useState([]);
  const [nextBillNumber, setNextBillNumber] = useState("001");
  const [foundBill, setFoundBill] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);

  // ========================================
  // ÉTATS POUR LE PAIEMENT COMBINÉ
  // ========================================
  const [showCombinedPayment, setShowCombinedPayment] = useState(false);
  const [combinedPaymentAmount, setCombinedPaymentAmount] = useState("");
  const [combinedPaymentMethod, setCombinedPaymentMethod] = useState("Espece");
  const [combinedPayments, setCombinedPayments] = useState([]);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [combinedPaymentHistory, setCombinedPaymentHistory] = useState([]);

  // ========================================
  // ÉTATS POUR LES POINTS CADEAUX
  // ========================================
  const [giftPointsTotal, setGiftPointsTotal] = useState(0);
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);
  const [giftPointsDetails, setGiftPointsDetails] = useState([]);

  // ========================================
  // ÉTATS POUR LE SCANNER QR CODE HTML5
  // ========================================
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [scannerResult, setScannerResult] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const scannerRef = useRef(null);

  // ========================================
  // ÉTATS POUR L'AJOUT DE POINTS PAR TÉLÉPHONE
  // ========================================
  const [showPointsPopup, setShowPointsPopup] = useState(false);
  const [clientPhone, setClientPhone] = useState("");
  const [clientName, setClientName] = useState("");
  const [pointsAddingLoading, setPointsAddingLoading] = useState(false);

  // Codes administrateurs autorisés - depuis la configuration
  const ADMIN_CODES = config?.features?.cancellation?.adminCodes || ["58587717", "98315003", "56332244"];

  const dispatch = useDispatch();
  const pendingTables = useSelector((state) => state.pendingTableReducer.pendingTables);

  //  Calcul des totaux avec promotions
  const calculateTotals = () => {
    // Calculer le total original (sans promotion)
    const totalOriginal = additionItems.reduce((sum, item) => {
      const originalPrice = item.originalPrice || item.price;
      return sum + (originalPrice * item.quantity);
    }, 0);

    // Calculer le total avec promotions par article
    const totalWithItemPromotions = additionItems.reduce((sum, item) => {
      let itemPrice = item.price;

      // Si l'article a une promotion, appliquer la réduction
      if (item.promotion && item.promotion.discount > 0) {
        const originalPrice = item.originalPrice || item.price;
        itemPrice = originalPrice * (1 - item.promotion.discount / 100);
      }

      return sum + (itemPrice * item.quantity);
    }, 0);

    // Appliquer la réduction générale
    const discountedTotal = discount > 0 ?
      totalWithItemPromotions * (1 - discount / 100) :
      totalWithItemPromotions;

    // Calculer HT et TVA
    const totalHT = discountedTotal / 1.07;
    const tva = totalHT * 0.07;

    return {
      totalHT: totalHT.toFixed(2),
      tva: tva.toFixed(2),
      totalTTC: discountedTotal.toFixed(2),
      totalOriginal: totalOriginal.toFixed(2),
      discountAmount: (totalOriginal - discountedTotal).toFixed(2)
    };
  };

  // 🔥 Mettez cette ligne APRÈS la fonction calculateTotals
  const { totalHT, tva, totalTTC } = calculateTotals();

  // ========================================
  // FONCTIONS POUR LES POINTS CADEAUX
  // ========================================

  // Fonction pour récupérer les points d'un sous-produit
  const getSubProductPoints = (subProductId) => {
    let points = 0;

    if (!menuData || menuData.length === 0) return points;

    // Rechercher le sous-produit dans tous les produits
    for (const product of menuData) {
      if (product.subProducts && Array.isArray(product.subProducts)) {
        const subProduct = product.subProducts.find(sp => sp._id === subProductId);
        if (subProduct && subProduct.giftPoints) {
          points = subProduct.giftPoints;
          break;
        }
      }
    }

    return points;
  };

  // Fonction pour calculer le total des points cadeaux
  const calculateGiftPoints = () => {
    if (!additionItems || additionItems.length === 0) return 0;

    let totalPoints = 0;
    const details = [];

    additionItems.forEach(item => {
      // Si c'est un sous-produit régulier
      if (!item.isDeal) {
        const itemPoints = getSubProductPoints(item.id);
        const subTotalPoints = itemPoints * item.quantity;
        totalPoints += subTotalPoints;

        details.push({
          name: item.name,
          quantity: item.quantity,
          pointsPerUnit: itemPoints,
          totalPoints: subTotalPoints
        });
      }
      // Si c'est un deal avec des sous-produits
      else if (item.isDeal && item.subProducts && item.subProducts.length > 0) {
        item.subProducts.forEach(sp => {
          const spPoints = getSubProductPoints(sp.id);
          const spTotalPoints = spPoints; // Un seul par sous-produit dans un deal
          totalPoints += spTotalPoints;

          details.push({
            name: `${item.name} - ${sp.name}`,
            quantity: 1,
            pointsPerUnit: spPoints,
            totalPoints: spTotalPoints
          });
        });
      }
    });

    setGiftPointsDetails(details);
    return totalPoints;
  };

  // Mettre à jour les points quand l'addition change
  useEffect(() => {
    const totalPoints = calculateGiftPoints();
    setGiftPointsTotal(totalPoints);
  }, [additionItems, menuData]);

  // Fonction pour ouvrir le modal QR Code
  const openQRCodeModal = () => {
    if (giftPointsTotal === 0) {
      alert("Aucun point cadeau à afficher");
      return;
    }
    setShowQRCodeModal(true);
  };

  // ========================================
  // FONCTIONS POUR LE SCANNER QR CODE HTML5
  // ========================================

  // Initialiser le scanner
  const initializeQRScanner = () => {
    if (scannerRef.current) {
      return;
    }

    // Configuration du scanner
    const configScanner = {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      rememberLastUsedCamera: true,
      // Note: Html5QrcodeScanType and Html5QrcodeSupportedFormats are automatically handled
    };

    // Créer l'instance du scanner
    scannerRef.current = new Html5QrcodeScanner(
      "qr-reader",
      configScanner,
      false
    );

    // Fonction de succès du scan
    const onScanSuccess = async (decodedText, decodedResult) => {
      console.log("✅ QR Code scanné:", decodedText);
      setScannerResult(decodedText);

      // Arrêter le scanner
      scannerRef.current.clear();
      setIsScanning(false);
      setShowQRScanner(false);

      // Traiter le résultat
      await processScannedQRCode(decodedText);
    };

    // Fonction d'erreur
    const onScanError = (error) => {
      console.warn("⚠️ Erreur scan QR:", error);
      // Ne pas arrêter le scanner en cas d'erreur
    };

    // Démarrer le scanner
    scannerRef.current.render(onScanSuccess, onScanError);
    setIsScanning(true);
  };

  // Arrêter le scanner
  const stopQRScanner = () => {
    if (scannerRef.current) {
      scannerRef.current.clear().catch(error => {
        console.error("Erreur arrêt scanner:", error);
      });
      scannerRef.current = null;
    }
    setIsScanning(false);
    setShowQRScanner(false);
  };

  // Ouvrir le scanner
  const openQRScanner = () => {
    setShowQRScanner(true);
    setScannerResult("");
    // L'initialisation se fait après le rendu du modal
  };

  // ========================================
  // AJOUT DE POINTS PAR TÉLÉPHONE
  // ========================================

  const handlePhoneInput = async (val) => {
    if (val === "DEL") {
      setClientPhone(prev => prev.slice(0, -1));
      setClientName(""); // Réinitialiser le nom si on efface
    } else if (clientPhone.length < 8) {
      const newPhone = clientPhone + val;
      setClientPhone(newPhone);

      // Vérifier automatiquement quand on atteint 8 chiffres
      if (newPhone.length === 8) {
        try {
          const response = await axios.post("/api/admin/clients/verify-phone", {
            phone: newPhone
          });

          if (response.data.success) {
            setClientName(response.data.client.name);
          } else {
            setClientName("");
            alert("❌ Client non trouvé avec ce numéro");
          }
        } catch (error) {
          console.error("Erreur vérification:", error);
          setClientName("");
          if (error.response?.status === 404) {
            alert("❌ Client non trouvé avec ce numéro");
          }
        }
      }
    }
  };

  // Lie le numéro de téléphone à la commande sans envoyer les points immédiatement
  const handleLinkPhoneToOrder = () => {
    if (!clientPhone || clientPhone.length < 8) {
      alert("Veuillez saisir un numéro de téléphone valide (8 chiffres)");
      return;
    }

    if (giftPointsTotal <= 0) {
      alert("Aucun point cadeau à ajouter pour cette commande");
      return;
    }

    alert(`✅ Le numéro ${clientPhone} est lié.\nLes points seront crédités automatiquement après confirmation du paiement.`);
    setShowPointsPopup(false);
  };

  // Fonction pour envoyer REELLEMENT les points au serveur de fidélité
  const applyPointsToClientLoyalty = async (points, phone, currentBillNum) => {
    if (!phone || points <= 0) return;

    try {
      console.log(`🚀 Appel API Fidélité pour ${phone}: ${points} pts`);
      const response = await axios.post("/api/admin/clients/add-points-by-phone", {
        phone: phone,
        points: points,
        description: `Points ajoutés depuis SPINTOSS - Facture #${currentBillNum || nextBillNumber}`,
        location: currentUser?.localisation?.name || 'Tunisia Mall'
      });

      if (response.data.success) {
        console.log(`✅ Fidélité: ${points} points ajoutés à ${response.data.client.name}`);
        return true;
      }
    } catch (error) {
      console.error("❌ Erreur Fidélité:", error);
      // On ne bloque pas le POS si la fidélité échoue, mais on log l'erreur
      return false;
    }
  };

  // Traiter le QR code scanné
  const processScannedQRCode = async (qrData) => {
    try {
      console.log("🔍 Traitement QR code:", qrData);

      let parsedData;

      // Essayer de parser comme JSON
      try {
        parsedData = JSON.parse(qrData);
        console.log("📊 QR code JSON détecté:", parsedData);
      } catch (e) {
        // Si ce n'est pas du JSON, traiter comme texte simple
        console.log("📝 QR code texte simple:", qrData);

        // Vérifier si c'est un code de points cadeaux
        if (qrData.startsWith("Kdo") || qrData.includes("SPINTOSS")) {
          parsedData = {
            code: qrData,
            type: "SPINTOSS_POINTS_SIMPLE"
          };
        } else {
          // Autres formats
          parsedData = {
            raw: qrData,
            type: "RAW_TEXT"
          };
        }
      }

      // Vérifier si c'est un QR code de points cadeaux SPINTOSS
      if (parsedData.type === "SPINTOSS_POINTS" ||
        parsedData.type === "SPINTOSS_POINTS_SIMPLE" ||
        parsedData.code?.startsWith("Kdo") ||
        parsedData.billNumber) {

        await processGiftPointsQRCode(parsedData);

      } else if (parsedData.type === "DISCOUNT_CARD") {
        // Traitement des cartes de réduction
        await processDiscountCardQRCode(parsedData);

      } else {
        // Format non reconnu
        alert(`QR code scanné mais format non reconnu:\n${qrData.substring(0, 100)}...`);
      }

    } catch (error) {
      console.error("❌ Erreur traitement QR code:", error);
      alert(`Erreur traitement QR code: ${error.message}`);
    }
  };

  // Traiter un QR code de points cadeaux
  const processGiftPointsQRCode = async (qrData) => {
    try {
      const token = localStorage.getItem("token");

      // Vérifier si le QR code existe déjà dans la base
      const checkResponse = await axios.get(`/api/qr/check/${qrData.code}`, {
        headers: { Authorised: token }
      });

      if (checkResponse.data.exists) {
        // QR code déjà utilisé
        const details = checkResponse.data.details;
        alert(`⚠️ QR code déjà utilisé!\n\n` +
          `Code: ${details.code}\n` +
          `Points: ${details.points}\n` +
          `Facture: ${details.billNumber}\n` +
          `Date: ${new Date(details.createdAt).toLocaleDateString()}\n` +
          `Utilisé par: ${details.usedBy?.name || "Inconnu"}`);
        return;
      }

      // Si c'est un QR code simple (sans JSON complet), récupérer les infos depuis la facture
      if (qrData.type === "SPINTOSS_POINTS_SIMPLE") {
        const billResponse = await axios.get(`/api/Bills/findByCode/${qrData.code}`, {
          headers: { Authorised: token }
        });

        if (billResponse.data.success) {
          qrData = {
            ...qrData,
            points: billResponse.data.bill.giftPointsTotal,
            billNumber: billResponse.data.bill.billNumber,
            items: billResponse.data.bill.items || []
          };
        }
      }

      // Afficher les informations
      const confirmAdd = window.confirm(
        `🎁 QR Code Points Cadeaux détecté!\n\n` +
        `Code: ${qrData.code}\n` +
        `Points: ${qrData.points}\n` +
        `Facture: ${qrData.billNumber}\n\n` +
        `Voulez-vous ajouter ${qrData.points} points au compte du client?`
      );

      if (confirmAdd) {
        // Demander l'ID du client
        const clientId = prompt(
          "Entrez l'ID du client (ou laissez vide pour un compte anonyme):",
          ""
        );

        // Marquer le QR code comme utilisé
        const useResponse = await axios.post('/api/qr/use', {
          qrCode: qrData.code,
          usedBy: currentUser._id,
          clientId: clientId || null,
          usedAt: new Date().toISOString()
        }, {
          headers: {
            Authorised: token,
            'Content-Type': 'application/json'
          }
        });

        if (useResponse.data.success) {
          alert(`✅ ${qrData.points} points ont été ajoutés au compte du client!`);

          // Optionnel: Créer une transaction de points
          if (clientId) {
            await axios.post('/api/loyalty/addPoints', {
              clientId: clientId,
              points: qrData.points,
              source: 'qr_code_scan',
              qrCode: qrData.code,
              billNumber: qrData.billNumber,
              scannedBy: currentUser._id
            }, {
              headers: {
                Authorised: token,
                'Content-Type': 'application/json'
              }
            });
          }
        }
      }

    } catch (error) {
      console.error("❌ Erreur traitement points cadeaux:", error);

      if (error.response?.status === 404) {
        alert("❌ QR code non trouvé dans la base de données");
      } else if (error.response?.status === 409) {
        alert("⚠️ Ce QR code a déjà été utilisé");
      } else {
        alert("Erreur lors du traitement du QR code");
      }
    }
  };

  // Traiter un QR code de carte de réduction
  const processDiscountCardQRCode = async (qrData) => {
    try {
      // Validation de la carte
      const validation = await validateDiscountCard(qrData.cardNumber);

      if (validation.success) {
        setDiscount(validation.card.discountPercentage);
        setDiscountCardNumber(qrData.cardNumber);

        alert(`✅ Carte de réduction validée!\n\n` +
          `Propriétaire: ${validation.card.owner}\n` +
          `Réduction: ${validation.card.discountPercentage}%\n` +
          `Solde restant: ${validation.card.remainingUses || "Illimité"}`);
      } else {
        alert(`❌ ${validation.message}`);
      }

    } catch (error) {
      console.error("Erreur traitement carte réduction:", error);
      alert("Erreur lors de la validation de la carte");
    }
  };

  // ========================================
  // MODAL POUR LE SCANNER QR CODE
  // ========================================
  const renderQRScannerModal = () => {
    if (!showQRScanner) return null;

    return (
      <div className="modal-overlay" style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.9)', display: 'flex', justifyContent: 'center',
        alignItems: 'center', zIndex: 3000
      }}>
        <div className="modal-content" style={{
          backgroundColor: 'black',
          padding: '20px',
          borderRadius: '10px',
          maxWidth: '600px',
          width: '90%',
          maxHeight: '90vh',
          textAlign: 'center',
          color: 'white'
        }}>
          <div className="modal-header" style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: '20px', paddingBottom: '10px', borderBottom: '1px solid #444'
          }}>
            <h3 style={{ margin: 0, color: 'white' }}>📷 Scanner QR Code</h3>
            <button
              onClick={stopQRScanner}
              style={{
                background: 'none', border: 'none', fontSize: '24px',
                cursor: 'pointer', color: 'white'
              }}
            >
              ✕
            </button>
          </div>

          <div className="scanner-instructions" style={{
            marginBottom: '20px',
            padding: '15px',
            backgroundColor: '#222',
            borderRadius: '8px'
          }}>
            <p style={{ margin: '0 0 10px 0', color: '#4CAF50' }}>
              <strong>Instructions:</strong>
            </p>
            <ul style={{
              textAlign: 'left',
              margin: '0',
              paddingLeft: '20px',
              fontSize: '14px',
              color: '#ccc'
            }}>
              <li>Placez le QR code dans le cadre de scan</li>
              <li>Assurez-vous d'avoir un bon éclairage</li>
              <li>Le scan est automatique</li>
              <li>Pour les points cadeaux: scannez le QR code du ticket</li>
              <li>Pour les cartes réduction: scannez le code-barres</li>
            </ul>
          </div>

          {/* Conteneur pour le scanner */}
          <div id="qr-reader" style={{
            width: '100%',
            minHeight: '300px',
            backgroundColor: '#111',
            borderRadius: '8px',
            overflow: 'hidden',
            marginBottom: '20px'
          }}></div>

          {scannerResult && (
            <div className="scan-result" style={{
              backgroundColor: '#333',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '20px',
              textAlign: 'left',
              wordBreak: 'break-all',
              fontSize: '12px',
              maxHeight: '100px',
              overflowY: 'auto'
            }}>
              <p style={{ margin: '0 0 5px 0', color: '#4CAF50' }}>
                <strong>Résultat du scan:</strong>
              </p>
              <pre style={{ margin: 0, color: '#fff' }}>
                {scannerResult.substring(0, 200)}
                {scannerResult.length > 200 ? '...' : ''}
              </pre>
            </div>
          )}

          <div className="scanner-status" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            marginBottom: '20px'
          }}>
            <div style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: isScanning ? '#4CAF50' : '#f44336',
              animation: isScanning ? 'pulse 1.5s infinite' : 'none'
            }}></div>
            <span style={{ color: isScanning ? '#4CAF50' : '#f44336' }}>
              {isScanning ? 'Scan en cours...' : 'Scanner arrêté'}
            </span>
          </div>

          <div className="modal-actions" style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'center'
          }}>
            <button
              onClick={() => {
                if (!isScanning) {
                  initializeQRScanner();
                }
              }}
              style={{
                padding: '12px 20px',
                backgroundColor: isScanning ? '#666' : '#2196F3',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: isScanning ? 'not-allowed' : 'pointer',
                opacity: isScanning ? 0.7 : 1
              }}
              disabled={isScanning}
            >
              {isScanning ? 'Scan en cours...' : 'Redémarrer le Scan'}
            </button>

            <button
              onClick={stopQRScanner}
              style={{
                padding: '12px 20px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Fermer le Scanner
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Initialiser le scanner quand le modal s'ouvre
  useEffect(() => {
    if (showQRScanner && !scannerRef.current) {
      // Petit délai pour permettre au DOM de se mettre à jour
      const timer = setTimeout(() => {
        initializeQRScanner();
      }, 100);

      return () => clearTimeout(timer);
    }

    // Nettoyer le scanner quand le composant se démonte
    return () => {
      if (scannerRef.current) {
        stopQRScanner();
      }
    };
  }, [showQRScanner]);

  // ========================================
  // FONCTIONS CONDITIONNELLES SELON CONFIG
  // ========================================

  // Vérifier si une section doit être affichée
  const shouldShowSection = (sectionName) => {
    if (!config) return true;
    return ConfigurationManager.shouldShowSection(sectionName);
  };

  // Vérifier si un élément doit être affiché
  const shouldShowElement = (elementName) => {
    if (!config) return true;
    return ConfigurationManager.shouldShowElement(elementName);
  };

  // Vérifier si le système de tables est activé
  const isTableSystemEnabled = () => {
    return config?.features?.tableSystem?.enabled && !isFoodTrackMode;
  };

  // Obtenir les méthodes de paiement depuis la config
  const getPaymentMethods = () => {
    return config?.features?.payment?.methods || ["Espece", "TPE", "T.Resto", "Glovo", "Yassir"];
  };

  // ========================================
  // RAFRAÎCHISSEMENT AUTOMATIQUE DES TABLES
  // ========================================
  useEffect(() => {
    // Ne pas rafraîchir les tables en mode foodtrack
    if (isFoodTrackMode) return;

    const refreshTables = () => {
      dispatch(getAllPendingTables());
    };

    refreshTables();
    const intervalId = setInterval(refreshTables, 10000);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refreshTables();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [dispatch, currentUser, isFoodTrackMode]);

  // ========================================
  // EFFET POUR CALCULER LE MONTANT RESTANT (PAIEMENT COMBINÉ)
  // ========================================
  useEffect(() => {
    // Utiliser calculateTotals() pour obtenir la valeur actuelle de totalTTC
    const totals = calculateTotals();
    const totalPaid = combinedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    const remaining = parseFloat(totals.totalTTC) - totalPaid;
    setRemainingAmount(remaining > 0 ? remaining : 0);

    // Mettre à jour l'historique des paiements
    const history = combinedPayments.map(payment => ({
      method: payment.method,
      amount: payment.amount.toFixed(2),
      timestamp: new Date().toLocaleTimeString()
    }));
    setCombinedPaymentHistory(history);
  }, [combinedPayments, additionItems, discount]); // Dépendances mises à jour

  // Configuration des logos pour les deux localisations réelles
  const getLocationConfig = () => {
    const locationName = currentUser?.localisation?.name?.toLowerCase() || "";

    const configs = {
      "jm": {
        logo: "/spintoss.png",
        name: "SPINTOSS JM",
        address: "JARDINS D'EL MENZAH 2"
      },
      "tm": {
        logo: "/spintoss.png",
        name: "SPINTOSS TM",
        address: "TUNISIA MALL"
      },
      "default": {
        logo: "/spintoss.png",
        name: "SPINTOSS",
        address: ""
      }
    };

    // Vérifier SPINTOSS JM
    if (locationName.includes("jm") || locationName.includes("menzah")) {
      return configs.jm;
    }

    // Vérifier SPINTOSS TM
    if (locationName.includes("tm") || locationName.includes("tunisia") || locationName.includes("mall")) {
      return configs.tm;
    }

    return configs.default;
  };

  // ========================================
  // FONCTIONS POUR CALCULER LES TOTAUX DES TABLES
  // ========================================
  const calculateTableTotal = (table) => {
    if (!table || !table.items || table.items.length === 0) return "0.00";

    const total = table.items.reduce((sum, item) => {
      const itemTotal = (item.price || 0) * (item.quantity || 1);
      return sum + itemTotal;
    }, 0);

    return total.toFixed(2);
  };

  const calculateTotalPendingTables = () => {
    const filteredTables = getFilteredPendingTables();

    const total = filteredTables.reduce((sum, table) => {
      const tableTotal = parseFloat(calculateTableTotal(table)) || 0;
      return sum + tableTotal;
    }, 0);

    return total.toFixed(2);
  };

  // Charger la liste du personnel
  useEffect(() => {
    // Vérifier si la fonctionnalité personnel est activée
    if (!config?.features?.staff?.enabled) {
      setStaffList([]);
      return;
    }

    const fetchStaffList = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("Aucun token d'authentification trouvé");
          setStaffList([]);
          return;
        }

        // Route principale des employés
        try {
          const response = await axios.get('/api/employees/', {
            headers: {
              Authorised: token,
              'Content-Type': 'application/json'
            }
          });

          let employees = [];

          // Gestion des différents formats de réponse
          if (Array.isArray(response.data)) {
            employees = response.data;
          } else if (response.data && Array.isArray(response.data.employees)) {
            employees = response.data.employees;
          } else if (response.data && Array.isArray(response.data.data)) {
            employees = response.data.data;
          } else if (response.data && response.data.success && Array.isArray(response.data.employees)) {
            employees = response.data.employees;
          } else {
            // Tentative d'extraction depuis n'importe quelle propriété array
            const possibleArrays = Object.values(response.data || {}).filter(item => Array.isArray(item));
            if (possibleArrays.length > 0) {
              employees = possibleArrays[0];
            }
          }

          if (employees.length > 0) {
            setStaffList(employees);
            return;
          }

        } catch (mainError) {
          console.error("Erreur route principale:", mainError);
        }

        // Fallback - Route d'authentification
        try {
          const fallbackResponse = await axios.get('/api/auth/GetEmployees', {
            headers: {
              Authorised: token,
              'Content-Type': 'application/json'
            }
          });

          if (fallbackResponse.data && fallbackResponse.data.success && Array.isArray(fallbackResponse.data.employees)) {
            setStaffList(fallbackResponse.data.employees);
            return;
          }
        } catch (error2) {
          console.error("Erreur fallback GetEmployees:", error2);
        }

        // Dernier fallback - AllUser
        try {
          const fallbackResponse2 = await axios.get('/api/auth/AllUser', {
            headers: {
              Authorised: token,
              'Content-Type': 'application/json'
            }
          });

          if (fallbackResponse2.data && fallbackResponse2.data.AllUser && Array.isArray(fallbackResponse2.data.AllUser)) {
            const staffUsers = fallbackResponse2.data.AllUser.filter(user =>
              (user.role === "user" || user.role === "userspintoss" || user.role === "employee") &&
              user.name
            );
            setStaffList(staffUsers);
            return;
          }
        } catch (error3) {
          console.error("Erreur fallback AllUser:", error3);
        }

        // Si toutes les routes échouent
        setStaffList([]);

      } catch (error) {
        console.error("Erreur générale chargement employés:", error);
        setStaffList([]);
      }
    };

    if (currentUser) {
      fetchStaffList();
    }
  }, [currentUser, config]);

  // Fonction utilitaire pour extraire l'ID de localisation
  const extractLocId = (loc) => {
    if (!loc) return null;

    if (typeof loc === "string") return loc;

    if (loc.$oid) return loc.$oid;

    if (loc._id) {
      if (typeof loc._id === 'string') return loc._id;
      if (loc._id.$oid) return loc._id.$oid;
      return loc._id.toString();
    }

    return loc.toString ? loc.toString() : String(loc);
  };

  // Filtrer les employés par localisation
  const getFilteredStaffByLocation = () => {
    if (!currentUser) return staffList;

    if (currentUser.role === "admin") return staffList;

    if (!currentUser.localisation) return staffList;

    const userLocationId = extractLocId(currentUser.localisation);

    return staffList.filter(employee => {
      if (!employee.localisation) return true;

      const employeeLocationId = extractLocId(employee.localisation);
      return employeeLocationId === userLocationId;
    });
  };

  const filteredStaffList = getFilteredStaffByLocation();

  // Gestion de la sélection du personnel
  const handleStaffSelect = (staffId) => {
    setSelectedStaff(staffId);
    const selected = staffList.find(staff => staff._id === staffId);
    if (selected) {
      console.log(`Personnel sélectionné: ${selected.name}`);
    }
  };

  // Activer l'addition personnel
  const activateStaffAddition = () => {
    // Vérifier si la fonctionnalité est activée
    if (!config?.features?.staff?.enabled) {
      alert("L'addition personnel est désactivée");
      return;
    }

    if (additionItems.length === 0) {
      alert("Veuillez d'abord ajouter des articles à l'addition");
      return;
    }

    if (filteredStaffList.length === 0) {
      alert("Aucun employé disponible dans votre localisation");
      return;
    }

    setShowStaffModal(true);
  };

  // Confirmer l'addition personnel
  const confirmStaffAddition = () => {
    if (!selectedStaff) {
      alert("Veuillez sélectionner un membre du personnel");
      return;
    }

    const selectedStaffMember = staffList.find(staff => staff._id === selectedStaff);
    if (!selectedStaffMember) {
      alert("Membre du personnel non trouvé");
      return;
    }

    // Utiliser le pourcentage de réduction depuis la config
    const staffDiscount = config?.features?.staff?.discountPercentage || 20;
    setDiscount(staffDiscount);
    setIsStaffAddition(true);

    setShowStaffModal(false);
  };

  // Réinitialiser l'addition personnel
  const resetStaffAddition = () => {
    setIsStaffAddition(false);
    setSelectedStaff("");
    setDiscount(0);
  };

  const canAccessStaffAddition = () => {
    if (!currentUser) return false;
    // Vérifier si la fonctionnalité est activée dans la config
    if (!config?.features?.staff?.enabled) return false;
    return currentUser.role === "admin" || currentUser.role === "userspintoss";
  };

  // 🔥 CORRIGÉ: Fonction pour générer le numéro de facture PAR LOCALISATION
  const getNextBillNumber = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      console.log(`📊 Génération numéro facture pour: ${today}`);

      const token = localStorage.getItem("token");
      const userLocationId = extractLocId(currentUser?.localisation);

      if (!userLocationId) {
        console.error("❌ Impossible de déterminer la localisation");
        const emergencyNumber = Math.floor(Math.random() * 900 + 100).toString();
        setNextBillNumber(emergencyNumber);
        return;
      }

      // OPTION 1: API backend avec gestion de la concurrence PAR LOCALISATION
      try {
        const response = await axios.get(`/api/Bills/generateBillNumber?date=${today}&locationId=${userLocationId}`, {
          headers: { Authorised: token }
        });

        if (response.data && response.data.billNumber) {
          const billNumber = response.data.billNumber.toString().padStart(3, '0');
          setNextBillNumber(billNumber);
          console.log(`✅ Numéro de facture API pour ${currentUser?.localisation?.name}: ${billNumber}`);
          return;
        }
      } catch (apiError) {
        console.warn("⚠️ API génération non disponible, fallback...", apiError);
      }

      // OPTION 2: Récupération du dernier numéro PAR LOCALISATION
      try {
        const response = await axios.get(`/api/Bills/getLastBillNumber?date=${today}&locationId=${userLocationId}`, {
          headers: { Authorised: token }
        });

        if (response.data && response.data.lastBillNumber) {
          const lastNumber = parseInt(response.data.lastBillNumber, 10);
          const nextNumber = (lastNumber + 1).toString().padStart(3, '0');
          setNextBillNumber(nextNumber);
          console.log(`✅ Dernier numéro pour ${currentUser?.localisation?.name}: ${lastNumber}, suivant: ${nextNumber}`);
          return;
        } else {
          // Première facture du jour pour cette localisation
          setNextBillNumber("001");
          console.log(`📊 Première facture du jour pour ${currentUser?.localisation?.name}: 001`);
          return;
        }
      } catch (lastNumberError) {
        console.warn("⚠️ Endpoint dernier numéro non disponible", lastNumberError);
      }

      // OPTION 3: Stockage local avec vérification de date ET LOCALISATION
      const todayDate = new Date().toISOString().split('T')[0];
      const locationKey = `loc_${userLocationId}`;
      const lastStoredDate = localStorage.getItem(`lastBillDate_${locationKey}`);
      let counter = 1;

      if (lastStoredDate === todayDate) {
        // Même jour - incrémenter le compteur pour cette localisation
        counter = parseInt(localStorage.getItem(`dailyBillCounter_${locationKey}`) || '1') + 1;
      } else {
        // Nouveau jour - réinitialiser à 1 pour cette localisation
        counter = 1;
        localStorage.setItem(`lastBillDate_${locationKey}`, todayDate);
      }

      localStorage.setItem(`dailyBillCounter_${locationKey}`, counter.toString());
      const billNumber = counter.toString().padStart(3, '0');
      setNextBillNumber(billNumber);
      console.log(`✅ Numéro de facture local pour ${currentUser?.localisation?.name}: ${billNumber}`);

    } catch (error) {
      console.error("❌ Erreur critique récupération numéro facture:", error);
      // Fallback d'urgence avec timestamp
      const emergencyNumber = Math.floor(Math.random() * 900 + 100).toString();
      setNextBillNumber(emergencyNumber);
      console.log(`🆘 Numéro de facture d'urgence: ${emergencyNumber}`);
    }
  };

  // ========================================
  // MODIFICATION: Filtrer les tables selon config ET trier par numéro
  // ========================================
  const getFilteredPendingTables = () => {
    // Si pas de tables ou mode foodtrack, retourner tableau vide
    if (!isTableSystemEnabled() || !pendingTables || pendingTables.length === 0) return [];

    let filtered = [];

    if (currentUser.role === "admin") {
      filtered = [...pendingTables];
    } else {
      const userLocationId = extractLocId(currentUser.localisation);

      filtered = pendingTables.filter(table => {
        const tableLocationId = extractLocId(table.location);
        return tableLocationId === userLocationId;
      });
    }

    // Trier les tables par numéro (ordre numérique)
    filtered.sort((a, b) => {
      // Convertir en nombres pour un tri numérique correct
      const numA = parseInt(a.tableNumber) || 0;
      const numB = parseInt(b.tableNumber) || 0;
      return numA - numB;
    });

    return filtered;
  };

  const filteredPendingTables = getFilteredPendingTables();

  // Vérification de localisation pour les sous-produits
  const isSubProductAccessible = (subProduct) => {
    if (!currentUser) return false;

    if (currentUser.role === "admin") return true;

    if (!currentUser.localisation) return false;

    const userLocationId = extractLocId(currentUser.localisation);
    const subProductLocation = extractLocId(subProduct.localisation);

    if (!subProductLocation) {
      return true;
    }

    return subProductLocation === userLocationId;
  };

  // Récupération des sous-produits avec vérification de localisation
  const getProductSubProducts = (productId) => {
    const product = menuData.find(p => p._id === productId);
    if (!product) return [];

    const subProducts = product.subProducts || [];

    return subProducts.filter(subProduct => {
      return isSubProductAccessible(subProduct);
    });
  };

  // Filtrage des produits par catégorie et localisation
  const getFilteredProducts = () => {
    if (!selectedCategory) return [];

    const categoryProducts = menuData.filter((product) => product.category === selectedCategory);

    return categoryProducts.filter(product => {
      if (currentUser.role === "admin") return true;

      const accessibleSubProducts = getProductSubProducts(product._id);
      return accessibleSubProducts.length > 0;
    });
  };

  // ========================================
  // MODIFICATION: Appliquer les promotions automatiquement
  // ========================================
  const applyPromotionToProduct = (product) => {
    if (!config?.promotions?.settings?.enablePromotions) {
      return product;
    }

    const discountInfo = ConfigurationManager.calculateDiscount(product);

    if (discountInfo.discount > 0) {
      console.log(`🎯 Promotion appliquée: ${discountInfo.promotionName} - ${discountInfo.discount}%`);
      // Ici vous pourriez appliquer le discount au prix
      // Pour l'instant, on retourne le produit avec l'info de promotion
      return {
        ...product,
        promotion: discountInfo
      };
    }

    return product;
  };

  // Fonction pour trouver l'ID d'un produit
  const findProductId = (productName) => {
    if (!productName) return null;

    // Recherche dans les produits principaux
    const mainProduct = allProducts.find(p =>
      p.name && p.name.trim().toUpperCase() === productName.trim().toUpperCase()
    );

    if (mainProduct) {
      return mainProduct._id;
    }

    // Recherche dans les sous-produits
    for (const product of allProducts) {
      if (product.subProducts && Array.isArray(product.subProducts)) {
        const subProduct = product.subProducts.find(sp =>
          sp.name && sp.name.trim().toUpperCase() === productName.trim().toUpperCase()
        );

        if (subProduct) {
          return subProduct._id;
        }
      }
    }

    // Recherche approximative
    for (const product of allProducts) {
      if (product.name && product.name.trim().toUpperCase().includes(productName.trim().toUpperCase())) {
        return product._id;
      }

      if (product.subProducts) {
        const subProduct = product.subProducts.find(sp =>
          sp.name && sp.name.trim().toUpperCase().includes(productName.trim().toUpperCase())
        );

        if (subProduct) {
          return subProduct._id;
        }
      }
    }

    return null;
  };

  // Fonction pour restaurer le stock
  const restoreStock = async (productId, quantity) => {
    try {
      const requestData = {
        products: [
          {
            id: productId,
            quantity: quantity,
          },
        ],
      };

      const response = await axios.post("/api/Stock/restoreStock", requestData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data && response.data.success) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Erreur restoreStock:", error);
      return false;
    }
  };

  // Chargement des données avec filtrage par localisation de l'utilisateur
  useEffect(() => {
    // Ne pas charger les tables en mode foodtrack
    if (!isFoodTrackMode) {
      dispatch(getAllPendingTables());
    }

    const fetchMenuData = async () => {
      try {
        if (!currentUser) {
          return;
        }

        const token = localStorage.getItem("token");

        let url = "/api/Product/getProduct";

        if (currentUser.role !== "admin" && currentUser.localisation) {
          const userLocationId = extractLocId(currentUser.localisation);
          url = `/api/Product/getProductByLocation/${userLocationId}`;
        }

        const { data } = await axios.get(url, {
          headers: { Authorised: token },
        });

        setMenuData(data);
        setAllProducts(data);

      } catch (err) {
        console.error("Erreur chargement menu:", err);
        try {
          const token = localStorage.getItem("token");
          const { data } = await axios.get("/api/Product/getProduct", {
            headers: { Authorised: token },
          });
          setMenuData(data);
          setAllProducts(data);
        } catch (fallbackErr) {
          console.error("Erreur fallback:", fallbackErr);
        }
      }
    };

    fetchMenuData();
    if (currentUser) {
      getNextBillNumber();
    }
  }, [dispatch, currentUser, isFoodTrackMode]);

  // 🔥 AJOUT: Re-générer le numéro quand la localisation change
  useEffect(() => {
    if (currentUser?.localisation) {
      getNextBillNumber();
    }
  }, [currentUser?.localisation]);

  // Fonction utilitaire pour créer un QR code (à placer avant les autres fonctions)
  const createQRCodeInDatabase = async (qrData) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post('/api/qr/create', qrData, {
        headers: {
          Authorised: token,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        console.log('✅ QR code créé dans la base:', response.data.qrCode.code);
        return response.data.qrCode;
      }
      return null;
    } catch (error) {
      console.error('❌ Erreur création QR code:', error);
      return null;
    }
  };

  // Déterminer les catégories disponibles selon le rôle et la localisation
  const getAvailableCategories = () => {
    if (!currentUser) return [];

    const role = currentUser.role;

    if (role === "userspintoss") {
      return ["FOOD", "BEVERAGES", "DEALS"];
    } else if (role === "admin") {
      return ["FOOD", "BEVERAGES", "DEALS"];
    }

    return [];
  };

  const availableCategories = getAvailableCategories();
  const filteredProducts = getFilteredProducts();

  // Sauvegarde des tables en attente (si système activé)
  useEffect(() => {
    if (isTableSystemEnabled()) {
      localStorage.setItem("pendingTables", JSON.stringify(pendingTables));
    }
  }, [pendingTables, isTableSystemEnabled]);

  // Initialiser les quantités partielles quand l'addition change
  useEffect(() => {
    const initialQuantities = {};
    additionItems.forEach(item => {
      initialQuantities[item.id] = item.quantity;
    });
    setPartialQuantities(initialQuantities);
  }, [additionItems]);

  // Gestion de l'interface produits/sous-produits
  const toggleSubProducts = (productId) => {
    const accessibleSubProducts = getProductSubProducts(productId);
    if (accessibleSubProducts.length === 0) {
      alert("Aucun sous-produit disponible dans votre localisation");
      return;
    }

    setSelectedProduct((prev) => (prev === productId ? null : productId));
  };

  // ========================================
  // MODIFICATION: Gestion de l'ajout avec promotions
  // ========================================
  const handleSubProductClick = (subProductId, subProductName, price, parentDealId) => {
    // En mode foodtrack, pas besoin de sélectionner de table
    if (!isFoodTrackMode && !tableNumber) {
      alert("Veuillez d'abord choisir une table avant d'ajouter des articles.");
      return;
    }

    const parentProduct = menuData.find(product => product._id === parentDealId);
    const subProduct = parentProduct?.subProducts?.find(sp => sp._id === subProductId);

    if (subProduct && !isSubProductAccessible(subProduct)) {
      alert("Ce produit n'est pas disponible dans votre localisation");
      return;
    }

    const parentDeal = menuData.find(product =>
      product._id === parentDealId && product.category === "DEALS"
    );

    if (parentDeal) {
      handleDealAddition(parentDeal, subProductId, subProductName, price);
    } else {
      handleRegularProductAddition(subProductId, subProductName, price);
    }
  };

  const handleDealAddition = (parentDeal, subProductId, subProductName, price) => {
    const existingDealIndex = additionItems.findIndex(item =>
      item.isDeal && item.dealId === parentDeal._id
    );

    if (existingDealIndex >= 0) {
      setAdditionItems(prev =>
        prev.map((item, index) =>
          index === existingDealIndex
            ? {
              ...item,
              subProducts: [
                ...item.subProducts,
                {
                  id: subProductId,
                  name: subProductName,
                  price,
                  parentDealId: parentDeal._id
                }
              ]
            }
            : item
        )
      );
    } else {
      setAdditionItems(prev => [
        ...prev,
        {
          id: parentDeal._id,
          dealId: parentDeal._id,
          name: parentDeal.name,
          price: parentDeal.price,
          quantity: 1,
          isDeal: true,
          subProducts: [{
            id: subProductId,
            name: subProductName,
            price,
            parentDealId: parentDeal._id
          }]
        }
      ]);
    }
  };

  const handleRegularProductAddition = (subProductId, subProductName, price) => {
    const existingItemIndex = additionItems.findIndex(item =>
      !item.isDeal && item.id === subProductId
    );

    // 🔥 CORRECTION : Sauvegarder le prix original
    const originalPrice = price;

    if (existingItemIndex >= 0) {
      setAdditionItems(prev =>
        prev.map((item, index) =>
          index === existingItemIndex
            ? {
              ...item,
              quantity: item.quantity + 1,
              originalPrice: item.originalPrice || originalPrice // Garder le prix original
            }
            : item
        )
      );
    } else {
      // Appliquer les promotions si activées
      const productWithPromotion = applyPromotionToProduct({
        id: subProductId,
        name: subProductName,
        price: price,
        originalPrice: price // Sauvegarder le prix original
      });

      setAdditionItems(prev => [
        ...prev,
        {
          id: subProductId,
          name: subProductName,
          price: productWithPromotion.promotion ?
            (price * (1 - productWithPromotion.promotion.discount / 100)) :
            price, // Prix avec promotion si applicable
          originalPrice: price, // Prix original sans promotion
          quantity: 1,
          isDeal: false,
          promotion: productWithPromotion.promotion
        }
      ]);
    }
  };

  // ========================================
  // MODIFICATION: Gestion des tables conditionnelle
  // ========================================
  const handleTableNumberInput = (num) => {
    if (num === "DEL") {
      setTableNumber("");
      setAdditionItems([]);
      setPaymentMethod(null);
      resetStaffAddition();
      setCombinedPayments([]);
      setShowCombinedPayment(false);
    } else {
      setTableNumber(num);
      const tableData = filteredPendingTables.find(table => table.tableNumber === num);
      setAdditionItems(tableData?.items || []);
      setCombinedPayments([]);
      setShowCombinedPayment(false);
    }
  };

  const switchTable = (tableNum) => {
    setTableNumber(tableNum);
    const tableData = filteredPendingTables.find(table => table.tableNumber === tableNum);
    setAdditionItems(tableData?.items || []);
    setPaymentMethod(null);
    setShowTablesPopup(false);
    setCombinedPayments([]);
    setShowCombinedPayment(false);
  };

  // Verrouillage de table
  const lockTable = async () => {
    if (!isTableSystemEnabled()) {
      alert("Le système de tables est désactivé");
      return;
    }

    if (!tableNumber || additionItems.length === 0) {
      alert("Veuillez sélectionner une table et ajouter des articles.");
      return;
    }

    try {
      const tableData = {
        tableNumber,
        items: additionItems,
        status: "locked",
        createdAt: new Date(),
        location: currentUser.localisation
      };

      const response = await axios.post(`/api/PendingTables/addPendingTable`, tableData);

      dispatch(getAllPendingTables());

      setTableNumber("");
      setAdditionItems([]);
      setPaymentMethod(null);
      resetStaffAddition();
      setCombinedPayments([]);
      setShowCombinedPayment(false);

    } catch (error) {
      console.error("Erreur lors du verrouillage :", error);
      alert(`Erreur lors du verrouillage: ${error.response?.data?.message || error.message}`);
    }
  };

  // TRANSFERT DE TABLE
  const openTransferModal = (tableNum) => {
    if (!config?.features?.tableSystem?.allowTableTransfer) {
      alert("Le transfert de tables est désactivé");
      return;
    }

    const table = filteredPendingTables.find(t => t.tableNumber === tableNum);
    if (table) {
      setTableToTransfer(table);
      setTransferTargetTable("");
      setShowTransferModal(true);
    }
  };

  const executeTableTransfer = async () => {
    if (!transferTargetTable || !tableToTransfer) {
      alert("Veuillez sélectionner une table de destination.");
      return;
    }

    if (transferTargetTable === tableToTransfer.tableNumber) {
      alert("La table de destination doit être différente de la table actuelle.");
      return;
    }

    const targetTableExists = filteredPendingTables.find(t => t.tableNumber === transferTargetTable);
    if (targetTableExists) {
      alert(`La table ${transferTargetTable} est déjà occupée. Veuillez choisir une autre table.`);
      return;
    }

    try {
      let deleteUrl = `/api/PendingTables/deletePendingTable/${tableToTransfer.tableNumber}`;

      await axios.delete(deleteUrl);

      const transferData = {
        tableNumber: transferTargetTable,
        items: tableToTransfer.items,
        status: "locked",
        createdAt: tableToTransfer.createdAt,
        transferredFrom: tableToTransfer.tableNumber,
        location: tableToTransfer.location || currentUser.localisation
      };

      await axios.post(`/api/PendingTables/addPendingTable`, transferData);

      dispatch(getAllPendingTables());

      if (tableNumber === tableToTransfer.tableNumber) {
        setTableNumber(transferTargetTable);
      }

      alert(`Table ${tableToTransfer.tableNumber} transférée vers la table ${transferTargetTable} avec succès !`);
      setShowTransferModal(false);
      setTableToTransfer(null);
      setTransferTargetTable("");

    } catch (error) {
      console.error("Erreur lors du transfert de table :", error);
      alert("Erreur lors du transfert de table. Vérifiez votre connexion.");
    }
  };

  // Gestion des articles
  const deleteItem = (id) => {
    setAdditionItems(prev => prev.filter(item => item.id !== id));
  };

  const modifyItem = (id, newQuantity) => {
    if (newQuantity < 1) return;
    setAdditionItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  // ========================================
  // MODIFICATION: Ouvrir le popup de paiement
  // ========================================
  const openPaymentModal = () => {
    // En mode foodtrack, pas besoin de table
    if (!isFoodTrackMode && !tableNumber) {
      alert("Veuillez sélectionner une table et ajouter des articles.");
      return;
    }

    if (additionItems.length === 0) {
      alert("Veuillez ajouter des articles.");
      return;
    }
    setShowPaymentModal(true);
  };

  // ========================================
  // NOUVELLE FONCTION: Paiement direct foodtrack
  // ========================================
  const handleDirectPayment = () => {
    if (additionItems.length === 0) {
      alert("Veuillez d'abord ajouter des articles.");
      return;
    }

    // En mode foodtrack, ouvrir directement le modal de paiement
    if (isFoodTrackMode) {
      setShowPaymentModal(true);
    } else {
      openPaymentModal();
    }
  };

  // ========================================
  // FONCTIONS POUR LE PAIEMENT COMBINÉ
  // ========================================
  const openCombinedPaymentModal = () => {
    if (!isFoodTrackMode && !tableNumber) {
      alert("Veuillez sélectionner une table et ajouter des articles.");
      return;
    }

    if (additionItems.length === 0) {
      alert("Veuillez ajouter des articles.");
      return;
    }

    setShowCombinedPayment(true);
    setCombinedPaymentAmount("");
    setCombinedPaymentMethod("Espece");
    setCombinedPayments([]);
  };

  const handleNumericInput = (value) => {
    if (value === "DEL") {
      setCombinedPaymentAmount("");
    } else if (value === ".") {
      if (!combinedPaymentAmount.includes(".")) {
        setCombinedPaymentAmount(prev => prev + ".");
      }
    } else {
      setCombinedPaymentAmount(prev => prev + value);
    }
  };

  const addCombinedPayment = () => {
    if (!combinedPaymentAmount || parseFloat(combinedPaymentAmount) <= 0) {
      alert("Veuillez saisir un montant valide");
      return;
    }

    const amount = parseFloat(combinedPaymentAmount);
    const totalPaid = combinedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    const totals = calculateTotals();
    const totalToPay = parseFloat(totals.totalTTC);

    if (amount > (totalToPay - totalPaid)) {
      alert(`Le montant saisi (${amount.toFixed(2)} DT) dépasse le montant restant (${(totalToPay - totalPaid).toFixed(2)} DT)`);
      return;
    }

    setCombinedPayments(prev => [
      ...prev,
      {
        method: combinedPaymentMethod,
        amount: amount,
        timestamp: new Date().toLocaleTimeString()
      }
    ]);

    setCombinedPaymentAmount("");
  };

  const removeCombinedPayment = (index) => {
    setCombinedPayments(prev => prev.filter((_, i) => i !== index));
  };

  // Nouvelle approche - Une seule facture avec détail des paiements
  const confirmCombinedPayment = async () => {
    if (combinedPayments.length === 0) {
      alert("Veuillez ajouter au moins un moyen de paiement");
      return;
    }

    const totalPaid = combinedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    const totals = calculateTotals();
    const totalToPay = parseFloat(totals.totalTTC);

    // Vérification
    if (Math.abs(totalPaid - totalToPay) > 0.01) {
      alert(`Erreur: Le montant total payé (${totalPaid.toFixed(2)} DT) ne correspond pas au total à payer (${totalToPay.toFixed(2)} DT)`);
      return;
    }

    setLoading(true);

    try {
      // 🔥 NOUVELLE APPROCHE: Une seule facture avec plusieurs modes de paiement
      const billData = {
        tableNumber: isFoodTrackMode ? autoTableNumber : tableNumber,
        items: additionItems.map(item => ({
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: item.quantity, // Quantités normales
          discountApplied: item.promotion?.discount || 0,
          promotionName: item.promotion?.promotionName || null,
          isDeal: item.isDeal || false,
          subProducts: item.subProducts || []
        })),
        paymentMethod: "Combiné", // 🔥 Mode de paiement spécial
        discount: discount,
        total: parseFloat(totalToPay.toFixed(2)), // Total complet
        tva: parseFloat(totals.tva),
        billNumber: nextBillNumber,
        date: new Date(),
        confirmationDate: new Date(),
        localisation: currentUser.localisation,
        locationId: extractLocId(currentUser.localisation),
        isStaffAddition: isStaffAddition,
        staffMember: isStaffAddition ? selectedStaff : null,
        // 🔥 INFORMATIONS DE PAIEMENT COMBINÉ
        isPartial: false, // Pas partiel car c'est le paiement complet
        combinedPayment: true,
        combinedPaymentIndex: 1, // Première et unique facture
        combinedPaymentTotal: 1,
        saleMode: isFoodTrackMode ? "direct" : "table",
        // 🔥 DÉTAIL DE TOUS LES PAIEMENTS
        combinedPaymentsDetail: combinedPayments.map(payment => ({
          method: payment.method,
          amount: payment.amount,
          timestamp: new Date()
        })),
        // 🔥 CHAMP POUR LE FRONTEND
        paymentMethodsSummary: combinedPayments.map(p => `${p.method}: ${p.amount.toFixed(2)} DT`).join(' + '),
        // 🔥 AJOUT DES POINTS CADEAUX
        giftPointsTotal: giftPointsTotal
      };

      console.log(`📝 Création facture combinée unique:`, {
        numéro: nextBillNumber,
        total: totalToPay,
        méthodes: combinedPayments.length,
        détail: billData.combinedPaymentsDetail,
        points: giftPointsTotal
      });

      const response = await axios.post("/api/Bills/createBill", billData);

      if (response.status >= 200 && response.status < 300) {
        // 🔥 AJOUTER LES POINTS APRÈS LE PAIEMENT SI UN NUMÉRO EST LIÉ
        if (clientPhone) {
          await applyPointsToClientLoyalty(giftPointsTotal, clientPhone, nextBillNumber);
        }

        // Imprimer
        printCombinedPaymentReceipt();

        // Réinitialiser
        try {
          if (!isFoodTrackMode && tableNumber) {
            await dispatch(deletePendingTable(tableNumber));
            setTimeout(() => {
              dispatch(getAllPendingTables());
            }, 500);
          }

          setAdditionItems([]);
          if (!isFoodTrackMode) setTableNumber("");
          setPaymentMethod(null);
          setDiscount(0);
          setDiscountCode("");
          resetStaffAddition();
          setCombinedPayments([]);
          setShowCombinedPayment(false);
          setGiftPointsTotal(0);
          setClientPhone("");
          setClientName("");

          // Incrémenter pour le prochain
          await getNextBillNumber();

          alert(`✅ Paiement combiné confirmé !`);
        } catch (resetError) {
          console.error("Erreur réinitialisation:", resetError);
        }
      }
    } catch (error) {
      console.error("❌ Erreur paiement combiné :", error);
      alert(`Erreur: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const printCombinedPaymentReceipt = () => {
    const locationConfig = getLocationConfig();
    const confirmationDate = new Date().toLocaleString();
    const staffInfo = isStaffAddition && selectedStaff ?
      staffList.find(s => s._id === selectedStaff) : null;

    // Calculer le total original et les économies
    const totalOriginal = additionItems.reduce((sum, item) => {
      return sum + ((item.originalPrice || item.price) * item.quantity);
    }, 0);

    const totalAfterPromotions = additionItems.reduce((sum, item) => {
      let itemPrice = item.price;
      if (item.promotion && item.promotion.discount > 0) {
        itemPrice = itemPrice * (1 - item.promotion.discount / 100);
      }
      return sum + (itemPrice * item.quantity);
    }, 0);

    const totalDiscountAmount = totalOriginal - totalAfterPromotions;

    // 🔥 CRÉER LES DONNÉES DU QR CODE - FORMAT OPTIMISÉ POUR LE SCANNER HTML5
    const uniqueCode = `Kdo${giftPointsTotal}-${nextBillNumber}-${Date.now().toString(16).toUpperCase().slice(-6)}`;

    // Format simple pour le scanner (texte lisible)
    const qrCodeText = JSON.stringify({
      c: uniqueCode, // code court
      p: giftPointsTotal, // points
      b: nextBillNumber, // numéro de facture
      l: currentUser?.localisation?.name?.substring(0, 3) || "SPT", // localisation courte
      d: new Date().toISOString().split('T')[0], // date
      t: parseFloat(totalTTC) // total
    });

    console.log("📊 Données QR code optimisées:", qrCodeText);

    const printableContent = `
      <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
        <div style="text-align:center; margin-bottom:10px;">
          <img src="${locationConfig.logo}" alt="Logo ${locationConfig.name}" style="max-width:150px; max-height:50px;" onerror="this.style.display='none'" />
        </div>
        <h1 style="margin:0; font-size:18px;">${locationConfig.name}</h1>
        ${locationConfig.address ? `<p style="margin:5px 0; font-size:12px;">${locationConfig.address}</p>` : ''}
        <h3 style="margin:10px 0; color:#333;">🔄 RECU DE PAIEMENT COMBINÉ</h3>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <p style="margin:5px 0;"><strong>Facture N°:</strong> ${nextBillNumber}</p>
          <p style="margin:5px 0;"><strong>Date:</strong> ${confirmationDate}</p>
          ${!isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Table:</strong> ${tableNumber}</p>` : ''}
          ${isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Mode:</strong> Vente Directe</p>` : ''}
          ${staffInfo ? `
            <p style="margin:5px 0;"><strong>Addition Personnel:</strong> ${staffInfo.name}</p>
          ` : ''}
          <p style="margin:5px 0;"><strong>Type:</strong> Paiement Combiné (${combinedPayments.length} partie${combinedPayments.length > 1 ? 's' : ''})</p>
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          ${additionItems.map(item => {
      const originalPrice = item.originalPrice || item.price;
      const finalPrice = item.price;
      const itemTotal = finalPrice * item.quantity;
      const itemDiscount = (originalPrice * item.quantity) - itemTotal;

      // Calculer les points pour cet item
      let itemPoints = 0;
      if (!item.isDeal) {
        itemPoints = getSubProductPoints(item.id);
      }

      return `
              <div style="display:flex; justify-content:space-between; margin:5px 0;">
                <span>{item.name} x{item.quantity}</span>
                <span>{itemTotal.toFixed(2)} DT</span>
              </div>
              ${item.promotion ? `
                <div style="margin-left: 10px; font-size:0.8em; color:#4CAF50;">
                  Promo: ${item.promotion.promotionName} -${item.promotion.discount}%
                  (Éco: ${itemDiscount.toFixed(2)} DT)
                </div>
              ` : ''}
              ${itemPoints > 0 ? `
                <div style="margin-left: 10px; font-size:0.8em; color:#9C27B0;">
                  Points cadeaux: ${itemPoints * item.quantity} pts
                </div>
              ` : ''}
            `;
    }).join('')}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          ${totalDiscountAmount > 0 ? `
            <div style="display:flex; justify-content:space-between;">
              <span>Total original:</span>
              <span>${totalOriginal.toFixed(2)} DT</span>
            </div>
            <div style="display:flex; justify-content:space-between; color:#4CAF50;">
              <span>Total promotions:</span>
              <span>-${totalDiscountAmount.toFixed(2)} DT</span>
            </div>
          ` : ''}
          <div style="display:flex; justify-content:space-between; font-weight:bold;">
            <span>Total TTC:</span>
            <span>{totalTTC} DT</span>
          </div>
          <div style="display:flex; justify-content:space-between; margin-top:5px;">
            <span>Total HT:</span>
            <span>{totalHT} DT</span>
          </div>
          <div style="display:flex; justify-content:space-between;">
            <span>TVA (7%):</span>
            <span>{tva} DT</span>
          </div>
          
          <!-- AJOUT DES POINTS CADEAUX -->
          ${giftPointsTotal > 0 ? `
            <div style="display:flex; justify-content:space-between; margin-top:10px; background-color:#F3E5F5; padding:5px; border-radius:3px;">
              <span style="font-weight:bold; color:#7B1FA2;">🎁 Total Points Cadeaux:</span>
              <span style="font-weight:bold; color:#7B1FA2;">${giftPointsTotal} points</span>
            </div>
          ` : ''}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <h4 style="margin:10px 0;">📋 DÉTAIL DES PAIEMENTS</h4>
          ${combinedPayments.map((payment, index) => `
            <div style="display:flex; justify-content:space-between; margin:5px 0; padding:5px; background:#f8f9fa; border-radius:3px;">
              <div>
                <strong>Partie ${index + 1}:</strong> ${payment.method}
              </div>
              <div>
                <strong>${payment.amount.toFixed(2)} DT</strong>
              </div>
            </div>
          `).join('')}
          <div style="display:flex; justify-content:space-between; font-weight:bold; margin-top:10px; border-top:2px solid #000; padding-top:5px;">
            <span>TOTAL PAYÉ:</span>
            <span>${combinedPayments.reduce((sum, p) => sum + p.amount, 0).toFixed(2)} DT</span>
          </div>
        </div>
        
        <!-- SECTION QR CODE POUR LES POINTS CADEAUX - OPTIMISÉE POUR LE SCANNER HTML5 -->
        ${giftPointsTotal > 0 ? `
          <hr style="border:1px solid #7B1FA2; margin:15px 0;"/>
          <div style="text-align:center; margin:15px 0;">
            <h4 style="color:#7B1FA2; margin-bottom:10px;">🎁 QR Code Points Cadeaux</h4>
            
            <div style="display:flex; align-items:center; justify-content:center; gap:15px;">
              <div style="width:120px; height:120px; background-color:#FFFFFF; border:2px solid #7B1FA2; 
                  border-radius:5px; display:flex; justify-content:center; align-items:center; overflow:hidden; padding:5px;">
                <!-- QR CODE OPTIMISÉ POUR LE SCANNER HTML5 -->
                <img 
                  src="https://api.qrserver.com/v1/create-qr-code/?size=110x110&data=${encodeURIComponent(qrCodeText)}&color=7B1FA2&bgcolor=FFFFFF&margin=5&format=png&ecc=H&qzone=1"
                  alt="QR Code Points Cadeaux"
                  style="width:110px; height:110px; max-width:100%;"
                  onload="console.log('QR code chargé: ${uniqueCode}')"
                  onerror="console.error('Erreur chargement QR code')"
                />
              </div>
              
              <div style="text-align:left; font-size:12px;">
                <div><strong>Code:</strong> ${uniqueCode}</div>
                <div><strong>Points:</strong> ${giftPointsTotal}</div>
                <div><strong>Facture:</strong> ${nextBillNumber}</div>
                <div><strong>Date:</strong> ${new Date().toLocaleDateString()}</div>
                <div><strong>Total:</strong> ${totalTTC} DT</div>
                <div style="margin-top:5px; font-size:10px; color:#666;">
                  Scan compatible HTML5 QR Code Scanner
                </div>
              </div>
            </div>
            
            <!-- INSTRUCTIONS POUR LE SCAN -->
            <div style="margin-top:15px; text-align:left; background:#F3E5F5; padding:10px; border-radius:5px; font-size:11px;">
              <p style="margin:0 0 5px 0; color:#7B1FA2; font-weight:bold;">Instructions de scan:</p>
              <ul style="margin:0; padding-left:15px;">
                <li>Ouvrez l'app SPINTOSS Scanner</li>
                <li>Scannez ce QR code avec la caméra</li>
                <li>Les points seront crédités automatiquement</li>
                <li>Conservez ce ticket comme preuve</li>
              </ul>
            </div>
          </div>
        ` : ''}
        
        <hr style="border:1px solid #000;"/>
        <div style="margin-top:15px; font-size:12px; color:#666;">
          <p>Merci et à bientôt !</p>
          ${giftPointsTotal > 0 ? `<p style="font-size:10px; color:#7B1FA2;">QR code compatible HTML5 QR Code Scanner</p>` : ''}
        </div>
      </div>
    `;

    // TEST: Afficher ce qui sera dans le QR code
    console.log("🔍 Test - Données QR code pour scanner:");
    console.log(qrCodeText);

    // TEST: Créer un QR code de test pour vérifier
    const testQRUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeText)}&color=000000&bgcolor=FFFFFF`;
    console.log("🔗 URL de test QR code:", testQRUrl);

    const printWindow = window.open('', '', 'width=350,height=700,left=100,top=100');
    printWindow.document.write(`
      <html>
        <head>
          <title>Paiement Combiné - Facture ${nextBillNumber}</title>
          <style>
            @media print {
              body { margin: 0; padding: 10px; }
              img { max-width: 100%; height: auto; }
            }
            @page { size: auto; margin: 5mm; }
            pre { white-space: pre-wrap; word-wrap: break-word; }
            @keyframes pulse {
              0% { opacity: 1; }
              50% { opacity: 0.5; }
              100% { opacity: 1; }
            }
          </style>
        </head>
        <body>
          ${printableContent}
          <script>
            window.onload = function() {
              console.log("🖨️ Impression de la facture ${nextBillNumber}");
              console.log("QR code contient:", \`${qrCodeText.substring(0, 100)}...\`);
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();

    // SAUVEGARDER DANS LA BASE DE DONNÉES
    if (giftPointsTotal > 0) {
      saveQRCodeToDatabase({
        code: uniqueCode,
        points: giftPointsTotal,
        billNumber: nextBillNumber,
        employeeId: currentUser?._id,
        location: currentUser?.localisation?.name || "spintoss-FaB",
        items: giftPointsDetails,
        totalAmount: parseFloat(totalTTC),
        qrText: qrCodeText, // Texte exact du QR code
        status: "active",
        createdAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
        metadata: {
          format: "html5_qrcode_compatible",
          scannerType: "Html5QrcodeScanner",
          optimizedFor: "mobile_scanning"
        }
      });
    }
  };

  // FONCTION POUR SAUVEGARDER LE QR CODE DANS LA BASE DE DONNÉES
  const saveQRCodeToDatabase = async (qrData) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post('/api/qr/create', qrData, {
        headers: {
          'Authorised': token,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        console.log('✅ QR code sauvegardé dans la base:', response.data.qrCode.code);
      }
    } catch (error) {
      console.error('❌ Erreur sauvegarde QR code:', error);
    }
  };

  // ========================================
  // VALIDATE DISCOUNT CARD - VERSION CORRECTE POUR VOTRE API
  // ========================================
  const validateDiscountCard = async (cardNumber) => {
    // 1. Vérification basique
    if (!cardNumber || !cardNumber.trim()) {
      return { success: false, message: "Numéro de carte requis" };
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return { success: false, message: "Session expirée" };
      }

      // 2. Appel API simple (POST /validate)
      const response = await axios.post(
        "/api/discountCards/validate",
        {
          cardNumber: cardNumber.trim(),
          locationId: extractLocId(currentUser?.localisation),
          purchaseAmount: parseFloat(calculateTotals().totalOriginal)
        },
        {
          headers: {
            'Authorised': token,
            'Content-Type': 'application/json'
          }
        }
      );

      // 3. Vérification de la réponse
      if (response.data.success === true) {
        return {
          success: true,
          card: response.data.card
        };
      } else {
        return {
          success: false,
          message: response.data.message || "Carte invalide"
        };
      }

    } catch (error) {
      // 4. Gestion d'erreur simple
      if (error.response?.status === 404) {
        return { success: false, message: "Carte non trouvée" };
      }
      if (error.response?.status === 400) {
        return { success: false, message: error.response.data.message || "Carte invalide" };
      }

      return {
        success: false,
        message: "Erreur de connexion au serveur"
      };
    }
  };

  // Dans confirmPaymentFromModal - Ajoutez cette section AVANT le paiement
  const confirmPaymentFromModal = async () => {
    if (!paymentMethod) {
      alert("Veuillez sélectionner un mode de paiement !");
      return;
    }

    // 🔥 VALIDATION AUTOMATIQUE DE LA CARTE POUR REMISE DE 10%
    // Dans confirmPaymentFromModal - section carte
    if (discount === 10 && discountCardNumber) {
      try {
        const token = localStorage.getItem("token");
        const totals = calculateTotals();

        await axios.post("/api/discountCards/record-usage", {
          cardNumber: discountCardNumber,
          billData: {
            billNumber: nextBillNumber,
            total: totals.totalTTC,
            locationId: extractLocId(currentUser.localisation),
            date: new Date()
          }
        }, {
          headers: {
            'Authorised': token,
            'Content-Type': 'application/json'
          }
        });

        console.log(`✅ Utilisation carte ${discountCardNumber} enregistrée`);

      } catch (error) {
        console.error("⚠️ Erreur enregistrement carte:", error);
        // Continuer quand même le paiement
      }
    }

    // Calculs des totaux...
    const totalOriginal = additionItems.reduce((sum, item) => {
      return sum + ((item.originalPrice || item.price) * item.quantity);
    }, 0);

    const discountAmount = (totalOriginal * discount) / 100;
    const totalAfterDiscount = totalOriginal - discountAmount;
    const tvaAfterDiscount = (totalAfterDiscount / 1.07) * 0.07;

    // Préparer les données de la facture
    const billData = {
      tableNumber: isFoodTrackMode ? autoTableNumber : tableNumber,
      items: additionItems.map(item => ({
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        originalPrice: item.originalPrice || item.price,
        discountApplied: item.promotion?.discount || 0,
        promotionName: item.promotion?.promotionName || null,
        generalDiscountApplied: discount > 0 ? discount : 0,
        isDeal: item.isDeal || false,
        dealId: item.dealId,
        subProducts: item.subProducts || []
      })),
      paymentMethod,
      discount: discount,
      // 🔥 AJOUT DU NUMÉRO DE CARTE DANS LES DONNÉES DE LA FACTURE
      discountCardNumber: discount === 10 ? discountCardNumber : null,
      total: totalAfterDiscount.toFixed(2),
      tva: tvaAfterDiscount.toFixed(2),
      originalTotal: totalOriginal.toFixed(2),
      totalDiscountAmount: discountAmount.toFixed(2),
      billNumber: nextBillNumber,
      localisation: currentUser.localisation,
      locationId: extractLocId(currentUser.localisation),
      isStaffAddition: isStaffAddition,
      staffMember: isStaffAddition ? selectedStaff : null,
      saleMode: isFoodTrackMode ? "direct" : "table",
      // 🔥 AJOUT DES POINTS CADEAUX
      giftPointsTotal: giftPointsTotal,
      clientName: clientName,
      clientPhone: clientPhone
    };

    setLoading(true);

    try {
      const response = await axios.post("/api/Bills/createBill", billData);

      if (response.status >= 200 && response.status < 300) {
        // 🔥 AJOUTER LES POINTS APRÈS LE PAIEMENT SI UN NUMÉRO EST LIÉ
        if (clientPhone) {
          await applyPointsToClientLoyalty(giftPointsTotal, clientPhone, nextBillNumber);
        }

        printAddition();
        await resetAfterPayment();
        await getNextBillNumber();

        setShowPaymentModal(false);
      }
    } catch (error) {
      console.error("Erreur lors du paiement :", error);
      alert("Échec du paiement. Vérifiez votre connexion et réessayez.");
    } finally {
      setLoading(false);
    }
  };

  const resetAfterPayment = async () => {
    try {
      // Ne pas supprimer de table en mode foodtrack
      if (!isFoodTrackMode && tableNumber) {
        await dispatch(deletePendingTable(tableNumber));

        setTimeout(() => {
          dispatch(getAllPendingTables());
        }, 500);
      }

      setAdditionItems([]);

      // En mode foodtrack, garder le même numéro de table auto
      if (!isFoodTrackMode) {
        setTableNumber("");
      }

      setPaymentMethod(null);
      setDiscount(0);
      setDiscountCode("");
      // 🔥 RÉINITIALISER LE NUMÉRO DE CARTE
      setDiscountCardNumber("");
      resetStaffAddition();
      setCombinedPayments([]);
      setShowCombinedPayment(false);
      setGiftPointsTotal(0);
      setClientPhone("");
      setClientName("");

      await getNextBillNumber();

    } catch (error) {
      console.error("Erreur lors de la réinitialisation:", error);
    }
  };

  // Paiement partiel
  const calculatePartialTotal = () => {
    const partialItems = additionItems
      .filter((item) => selectedPartialItems.includes(item.id))
      .map(item => ({
        ...item,
        quantity: partialQuantities[item.id] || item.quantity
      }));

    const total = partialItems.reduce((sum, item) =>
      sum + item.price * (partialQuantities[item.id] || item.quantity), 0);
    const discounted = total - (total * discount) / 100;
    return discounted.toFixed(2);
  };

  const togglePartialItem = (itemId) => {
    setSelectedPartialItems((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };

  const modifyPartialQuantity = (itemId, newQuantity) => {
    if (newQuantity < 0) return;

    setPartialQuantities(prev => ({
      ...prev,
      [itemId]: newQuantity
    }));
  };

  const getPartialQuantity = (itemId) => {
    return partialQuantities[itemId] !== undefined ? partialQuantities[itemId] :
      additionItems.find(item => item.id === itemId)?.quantity || 0;
  };

  const confirmPartialPayment = async () => {
    if (!config?.features?.payment?.allowPartialPayment) {
      alert("Le paiement partiel est désactivé");
      return;
    }

    if (selectedPartialItems.length === 0) {
      alert("Veuillez sélectionner des articles à payer partiellement !");
      return;
    }
    if (!paymentMethod) {
      alert("Veuillez sélectionner un mode de paiement !");
      return;
    }

    const invalidItems = selectedPartialItems.filter(itemId => {
      const partialQty = getPartialQuantity(itemId);
      const originalItem = additionItems.find(item => item.id === itemId);
      return !originalItem || partialQty < 0 || partialQty > originalItem.quantity;
    });

    if (invalidItems.length > 0) {
      alert("Certaines quantités partielles sont invalides !");
      return;
    }

    const partialItems = additionItems
      .filter((item) => selectedPartialItems.includes(item.id))
      .map(item => ({
        ...item,
        quantity: getPartialQuantity(item.id),
        originalQuantity: item.quantity
      }));

    const partialTotal = calculatePartialTotal();
    const partialTVA = (partialTotal / 1.07 * 0.07).toFixed(2);

    try {
      const response = await axios.post("/api/Bills/createBill", {
        tableNumber: isFoodTrackMode ? autoTableNumber : tableNumber,
        items: partialItems,
        paymentMethod,
        discount,
        total: partialTotal,
        tva: partialTVA,
        billNumber: nextBillNumber,
        date: new Date(),
        confirmationDate: new Date(),
        isPartial: true,
        location: currentUser.localisation,
        locationId: extractLocId(currentUser.localisation),
        isStaffAddition: isStaffAddition,
        staffMember: isStaffAddition ? {
          _id: selectedStaff,
          name: staffList.find(s => s._id === selectedStaff)?.name,
          matricule: staffList.find(s => s._id === selectedStaff)?.matricule || staffList.find(s => s._id === selectedStaff)?.employeeId || staffList.find(s => s._id === selectedStaff)?.code || 'N/A'
        } : null,
        saleMode: isFoodTrackMode ? "direct" : "table",
        // 🔥 AJOUT DES POINTS CADEAUX POUR LE PAIEMENT PARTIEL
        giftPointsTotal: calculateGiftPointsForPartial(partialItems)
      });

      if (response.status >= 200 && response.status < 300) {
        // 🔥 AJOUTER LES POINTS APRÈS LE PAIEMENT SI UN NUMÉRO EST LIÉ
        // On calcule les points uniquement pour les articles payés partiellement
        if (clientPhone) {
          const partialPoints = calculateGiftPointsForPartial(partialItems);
          await applyPointsToClientLoyalty(partialPoints, clientPhone, nextBillNumber);
        }

        printPartialAddition(partialItems);

        const updatedAdditionItems = additionItems.map(item => {
          if (selectedPartialItems.includes(item.id)) {
            const remainingQuantity = item.quantity - getPartialQuantity(item.id);
            return { ...item, quantity: remainingQuantity };
          }
          return item;
        }).filter(item => item.quantity > 0);

        setAdditionItems(updatedAdditionItems);
        setSelectedPartialItems([]);
        setShowPartialPayment(false);
        setPartialQuantities({});

        await getNextBillNumber();
      }
    } catch (error) {
      console.error("Erreur paiement partiel :", error);
      alert("Erreur lors du paiement partiel. Vérifiez votre connexion.");
    }
  };

  // Fonction pour calculer les points cadeaux pour le paiement partiel
  const calculateGiftPointsForPartial = (partialItems) => {
    let totalPoints = 0;

    partialItems.forEach(item => {
      if (!item.isDeal) {
        const itemPoints = getSubProductPoints(item.id);
        totalPoints += itemPoints * item.quantity;
      } else if (item.isDeal && item.subProducts) {
        item.subProducts.forEach(sp => {
          const spPoints = getSubProductPoints(sp.id);
          totalPoints += spPoints;
        });
      }
    });

    return totalPoints;
  };

  // FONCTION POUR IMPRIMER L'ADDITION AVANT PAIEMENT
  const printAdditionOnly = () => {
    if (!isFoodTrackMode && !tableNumber) {
      alert("Veuillez sélectionner une table et ajouter des articles pour imprimer l'addition.");
      return;
    }

    if (additionItems.length === 0) {
      alert("Veuillez ajouter des articles.");
      return;
    }

    const locationConfig = getLocationConfig();
    const currentDate = new Date().toLocaleString();
    const staffInfo = isStaffAddition && selectedStaff ?
      staffList.find(s => s._id === selectedStaff) : null;

    const printableContent = `
      <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
        <div style="text-align:center; margin-bottom:10px;">
          <img src="${locationConfig.logo}" alt="Logo ${locationConfig.name}" style="max-width:150px; max-height:50px;" onerror="this.style.display='none'" />
        </div>
        <h1 style="margin:0; font-size:18px;">${locationConfig.name}</h1>
        ${locationConfig.address ? `<p style="margin:5px 0; font-size:12px;">${locationConfig.address}</p>` : ''}
        <h3 style="margin:10px 0; color:#333;">ADDITION</h3>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          ${!isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Table:</strong> ${tableNumber}</p>` : ''}
          <p style="margin:5px 0;"><strong>Date:</strong> ${currentDate}</p>
          <p style="margin:5px 0;"><strong>Addition N°:</strong> ${nextBillNumber}</p>
          ${isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Mode:</strong> Vente Directe</p>` : ''}
          ${staffInfo ? `
            <p style="margin:5px 0;"><strong>Personnel:</strong> ${staffInfo.name}</p>
            <p style="margin:5px 0;"><strong>Matricule:</strong> ${staffInfo.matricule || staffInfo.employeeId || staffInfo.code || 'N/A'}</p>
          ` : ''}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          ${additionItems.map(item => {
      // Calculer les points pour cet item
      let itemPoints = 0;
      if (!item.isDeal) {
        itemPoints = getSubProductPoints(item.id);
      }

      return `
              <div style="display:flex; justify-content:space-between; margin:5px 0;">
                <span>${item.name} x${item.quantity}</span>
                <span>${(item.price * item.quantity).toFixed(2)} DT</span>
              </div>
              ${item.isDeal && item.subProducts ? item.subProducts.map(sp =>
        `<div style="margin-left: 10px; font-size:0.9em; color:#666;">- ${sp.name}</div>`
      ).join('') : ''}
              ${item.promotion ? `<div style="margin-left: 10px; font-size:0.8em; color:#4CAF50;">Promo: ${item.promotion.promotionName} -${item.promotion.discount}%</div>` : ''}
              ${itemPoints > 0 ? `<div style="margin-left: 10px; font-size:0.8em; color:#9C27B0;">Points cadeaux: ${itemPoints * item.quantity} pts</div>` : ''}
            `;
    }).join('')}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <div style="display:flex; justify-content:space-between;">
            <span>Total HT:</span>
            <span>${totalHT} DT</span>
          </div>
          <div style="display:flex; justify-content:space-between;">
            <span>TVA (7%):</span>
            <span>${tva} DT</span>
          </div>
          ${discount > 0 ? `
            <div style="display:flex; justify-content:space-between; color:#d32f2f;">
              <span>Remise (${discount}%):</span>
              <span>-${(additionItems.reduce((sum, item) => sum + item.price * item.quantity, 0) * discount / 100).toFixed(2)} DT</span>
            </div>
          ` : ''}
          
          <!-- AJOUT DES POINTS CADEAUX -->
          ${giftPointsTotal > 0 ? `
            <div style="display:flex; justify-content:space-between; margin-top:10px; background-color:#F3E5F5; padding:5px; border-radius:3px;">
              <span style="font-weight:bold; color:#7B1FA2;">🎁 Total Points Cadeaux:</span>
              <span style="font-weight:bold; color:#7B1FA2;">${giftPointsTotal} points</span>
            </div>
          ` : ''}
          
          <div style="display:flex; justify-content:space-between; font-weight:bold; margin-top:5px;">
            <span>Total TTC:</span>
            <span>${totalTTC} DT</span>
          </div>
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="margin-top:15px; font-size:12px; color:#666;">
          <p>Merci pour votre visite !</p>
          <p>À bientôt chez ${locationConfig.name}</p>
        </div>
      </div>
    `;

    printContent(printableContent);
  };

  // Fonction pour imprimer l'addition (sans passer par le paiement)
  const printAdditionDirect = () => {
    if (!isFoodTrackMode && !tableNumber) {
      alert("Veuillez sélectionner une table et ajouter des articles pour imprimer l'addition.");
      return;
    }

    if (additionItems.length === 0) {
      alert("Veuillez ajouter des articles.");
      return;
    }

    const locationConfig = getLocationConfig();
    const currentDate = new Date().toLocaleString();
    const staffInfo = isStaffAddition && selectedStaff ?
      staffList.find(s => s._id === selectedStaff) : null;

    // Calculer les points cadeaux totaux
    const pointsTotal = calculateGiftPoints();

    const printableContent = `
    <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
      <div style="text-align:center; margin-bottom:10px;">
        <img src="${locationConfig.logo}" alt="Logo ${locationConfig.name}" style="max-width:150px; max-height:50px;" onerror="this.style.display='none'" />
      </div>
      <h1 style="margin:0; font-size:18px;">${locationConfig.name}</h1>
      ${locationConfig.address ? `<p style="margin:5px 0; font-size:12px;">${locationConfig.address}</p>` : ''}
      <h3 style="margin:10px 0; color:#333; border-bottom:2px solid #000; padding-bottom:5px;">ADDITION</h3>
      <hr style="border:1px solid #000;"/>
      <div style="text-align:left; margin:10px 0;">
        ${!isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Table:</strong> ${tableNumber}</p>` : ''}
        <p style="margin:5px 0;"><strong>Date:</strong> ${currentDate}</p>
        <p style="margin:5px 0;"><strong>Addition N°:</strong> ${nextBillNumber}</p>
        ${isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Mode:</strong> Vente Directe</p>` : ''}
        ${staffInfo ? `
          <p style="margin:5px 0;"><strong>Personnel:</strong> ${staffInfo.name}</p>
          <p style="margin:5px 0;"><strong>Matricule:</strong> ${staffInfo.matricule || staffInfo.employeeId || staffInfo.code || 'N/A'}</p>
        ` : ''}
        <p style="margin:5px 0;"><strong>État:</strong> EN ATTENTE DE PAIEMENT</p>
      </div>
      <hr style="border:1px solid #000;"/>
      <div style="text-align:left; margin:10px 0;">
        ${additionItems.map(item => {
      // Calculer les points pour cet item
      let itemPoints = 0;
      if (!item.isDeal) {
        itemPoints = getSubProductPoints(item.id);
      }

      return `
            <div style="display:flex; justify-content:space-between; margin:5px 0; padding:3px 0;">
              <div style="flex: 2;">
                <div style="font-weight:bold;">${item.name} x${item.quantity}</div>
                ${item.isDeal && item.subProducts ? item.subProducts.map(sp =>
        `<div style="margin-left: 10px; font-size:0.9em; color:#666;">- ${sp.name}</div>`
      ).join('') : ''}
                ${item.promotion ? `<div style="margin-left: 10px; font-size:0.8em; color:#4CAF50;">Promo: ${item.promotion.promotionName} -${item.promotion.discount}%</div>` : ''}
                ${itemPoints > 0 ? `<div style="margin-left: 10px; font-size:0.8em; color:#9C27B0;">Points: ${itemPoints * item.quantity} pts</div>` : ''}
              </div>
              <div style="flex: 1; text-align:right;">
                <div style="font-weight:bold;">${(item.price * item.quantity).toFixed(2)} DT</div>
                <div style="font-size:0.8em; color:#666;">{item.price.toFixed(2)} DT/u</div>
              </div>
            </div>
          `;
    }).join('')}
      </div>
      <hr style="border:2px solid #000;"/>
      <div style="text-align:left; margin:10px 0;">
        <div style="display:flex; justify-content:space-between; margin:5px 0;">
          <span>Sous-total:</span>
          <span>${calculateTotals().totalOriginal} DT</span>
        </div>
        ${discount > 0 ? `
          <div style="display:flex; justify-content:space-between; margin:5px 0; color:#d32f2f;">
            <span>Remise (${discount}%):</span>
            <span>-${(parseFloat(calculateTotals().totalOriginal) * discount / 100).toFixed(2)} DT</span>
          </div>
        ` : ''}
        <div style="display:flex; justify-content:space-between; margin:5px 0;">
          <span>Total HT:</span>
          <span>${totalHT} DT</span>
        </div>
        <div style="display:flex; justify-content:space-between; margin:5px 0;">
          <span>TVA (7%):</span>
          <span>${tva} DT</span>
        </div>
        
        <!-- POINTS CADEAUX -->
        ${pointsTotal > 0 ? `
          <div style="display:flex; justify-content:space-between; margin-top:10px; background-color:#F3E5F5; padding:8px; border-radius:4px; border:1px solid #7B1FA2;">
            <span style="font-weight:bold; color:#7B1FA2;">🎁 Points cadeaux:</span>
            <span style="font-weight:bold; color:#7B1FA2;">${pointsTotal} points</span>
          </div>
        ` : ''}
        
        <div style="display:flex; justify-content:space-between; font-weight:bold; margin-top:10px; padding-top:10px; border-top:2px solid #000;">
          <span>TOTAL À PAYER:</span>
          <span style="font-size:18px;">${totalTTC} DT</span>
        </div>
      </div>
      <hr style="border:1px solid #000;"/>
      <div style="margin-top:20px; font-size:12px; color:#666; text-align:center;">
        <p style="font-weight:bold; margin-bottom:5px;">PRIORITÉ À L'ADDITION IMPRIMÉE</p>
        <p>Merci de présenter cette addition pour régler</p>
        <p>${locationConfig.name} - ${locationConfig.address}</p>
        <p style="margin-top:10px; color:#ff0000; font-weight:bold;">⚠️ CETTE ADDITION N'EST PAS UN REÇU DE PAIEMENT</p>
      </div>
    </div>
  `;

    // Ouvrir la fenêtre d'impression
    const printWindow = window.open('', '', 'width=350,height=600,left=100,top=100');

    printWindow.document.write(`
    <html>
      <head>
        <title>Addition - ${isFoodTrackMode ? 'Vente Directe' : `Table ${tableNumber}`}</title>
        <style>
          @media print {
            body { margin: 0; padding: 10px; }
            @page { size: auto; margin: 5mm; }
            .no-print { display: none; }
          }
          img { max-width: 100%; height: auto; }
          body { font-family: 'Courier New', monospace; }
        </style>
      </head>
      <body onload="setTimeout(() => { window.print(); setTimeout(() => window.close(), 500); }, 500);">
        ${printableContent}
        <div class="no-print" style="text-align:center; margin-top:20px; padding:10px; background:#f8f9fa;">
          <button onclick="window.print()" style="padding:10px 20px; background:#28a745; color:white; border:none; border-radius:5px; cursor:pointer; margin:5px;">
            🖨️ Imprimer à nouveau
          </button>
          <button onclick="window.close()" style="padding:10px 20px; background:#dc3545; color:white; border:none; border-radius:5px; cursor:pointer; margin:5px;">
            ❌ Fermer
          </button>
        </div>
      </body>
    </html>
  `);
    printWindow.document.close();
  };

  const printAddition = async () => {
    const locationConfig = getLocationConfig();
    const confirmationDate = new Date().toLocaleString();
    const staffInfo = isStaffAddition && selectedStaff ?
      staffList.find(s => s._id === selectedStaff) : null;

    const totalOriginal = additionItems.reduce((sum, item) => {
      return sum + ((item.originalPrice || item.price) * item.quantity);
    }, 0);

    const discountAmount = (totalOriginal * discount) / 100;
    const totalAfterDiscount = totalOriginal - discountAmount;

    // 🔥 CRÉER LES DONNÉES DU QR CODE - FORMAT COMPATIBLE HTML5 QR CODE SCANNER
    const uniqueCode = `Kdo${giftPointsTotal}-${nextBillNumber}-${Date.now().toString(16).toUpperCase().slice(-6)}`;

    // Format optimisé pour le scanner
    const qrCodeText = JSON.stringify({
      c: uniqueCode, // code
      p: giftPointsTotal, // points
      b: nextBillNumber, // bill number
      l: currentUser?.localisation?.name?.substring(0, 3) || "SPT", // location
      d: new Date().toISOString().split('T')[0], // date
      t: parseFloat(totalAfterDiscount.toFixed(2)), // total
      m: paymentMethod?.substring(0, 1) || "C" // payment method first letter
    });

    console.log("📊 Données QR code (paiement normal):", qrCodeText);

    let qrCodeCreated = false;
    let serverQRCode = null;

    // 🔥 CRÉER LE QR CODE DANS LA BASE SI DES POINTS EXISTENT
    if (giftPointsTotal > 0) {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token non trouvé");
        }

        console.log("📤 Tentative création QR code pour facture:", nextBillNumber);

        // 1. Appeler l'API pour créer le QR code dans la base
        const response = await axios.post('/api/qr/create', {
          code: uniqueCode,
          points: giftPointsTotal,
          billNumber: nextBillNumber,
          location: currentUser?.localisation?.name || "SPINTOSS",
          items: giftPointsDetails,
          totalAmount: parseFloat(totalAfterDiscount.toFixed(2)),
          qrText: qrCodeText, // Texte exact du QR code
          status: "active",
          createdAt: new Date().toISOString(),
          metadata: {
            scannerCompatible: true,
            format: "html5_qrcode",
            paymentMethod: paymentMethod,
            table: !isFoodTrackMode ? tableNumber : "VENTE_DIRECTE",
            staffAddition: isStaffAddition
          }
        }, {
          headers: {
            'Authorised': token,
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });

        if (response.data && response.data.success) {
          serverQRCode = response.data.qrCode;
          qrCodeCreated = true;

          console.log("✅ QR code créé dans la base:", uniqueCode, "ID:", serverQRCode.id || serverQRCode._id);

          // 2. Mettre à jour la facture avec le code QR
          try {
            await axios.put(`/api/Bills/updateBill/${nextBillNumber}`, {
              qrCode: uniqueCode,
              qrCodeId: serverQRCode.id || serverQRCode._id,
              giftPointsTotal: giftPointsTotal,
              updatedAt: new Date().toISOString()
            }, {
              headers: { 'Authorised': token },
              timeout: 5000
            });
            console.log("✅ Facture mise à jour avec QR code");
          } catch (updateError) {
            console.warn("⚠️ Mise à jour facture échouée:", updateError.message);
          }

        } else {
          throw new Error(response.data?.message || 'Erreur création QR code');
        }

      } catch (error) {
        console.error("❌ Erreur création QR code:", error.message || error);

        // Fallback: utiliser le code local
        console.warn("⚠️ Utilisation code local:", uniqueCode);
      }
    }

    const printableContent = `
      <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
        <div style="text-align:center; margin-bottom:10px;">
          <img src="${locationConfig.logo}" alt="Logo ${locationConfig.name}" style="max-width:150px; max-height:50px;" onerror="this.style.display='none'" />
        </div>
        <h1 style="margin:0; font-size:18px;">${locationConfig.name}</h1>
        ${locationConfig.address ? `<p style="margin:5px 0; font-size:12px;">${locationConfig.address}</p>` : ''}
        <h3 style="margin:10px 0; color:#333;">Reçu de paiement</h3>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <p style="margin:5px 0;"><strong>Facture N°:</strong> ${nextBillNumber}</p>
          <p style="margin:5px 0;"><strong>Date:</strong> ${confirmationDate}</p>
          ${!isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Table:</strong> ${tableNumber}</p>` : ''}
          ${isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Mode:</strong> Vente Directe</p>` : ''}
          ${staffInfo ? `
            <p style="margin:5px 0;"><strong>Addition Personnel:</strong> ${staffInfo.name}</p>
          ` : ''}
          ${discount === 10 && discountCardNumber ? `
            <p style="margin:5px 0;"><strong>Carte réduction:</strong> ${discountCardNumber}</p>
          ` : ''}
          ${giftPointsTotal > 0 ? `
            <p style="margin:5px 0;"><strong>Code points:</strong> ${uniqueCode}</p>
            ${!qrCodeCreated ? `<p style="margin:5px 0; font-size:11px; color:#ff9800;">⚠️ Code local - à saisir manuellement si problème</p>` : ''}
          ` : ''}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          ${additionItems.map(item => {
      const originalPrice = item.originalPrice || item.price;
      const finalPrice = item.price;
      const itemTotal = finalPrice * item.quantity;

      // Calculer les points pour cet item
      let itemPoints = 0;
      if (!item.isDeal) {
        itemPoints = getSubProductPoints(item.id);
      }

      return `
              <div style="display:flex; justify-content:space-between; margin:5px 0;">
                <span>${item.name} x${item.quantity}</span>
                <span>${itemTotal.toFixed(2)} DT</span>
              </div>
              ${item.promotion ? `
                <div style="margin-left: 10px; font-size:0.8em; color:#4CAF50;">
                  Promo: ${item.promotion.promotionName} -${item.promotion.discount}%
                </div>
              ` : ''}
              ${itemPoints > 0 ? `
                <div style="margin-left: 10px; font-size:0.8em; color:#9C27B0;">
                  Points cadeaux: ${itemPoints * item.quantity} pts
                </div>
              ` : ''}
            `;
    }).join('')}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <div style="display:flex; justify-content:space-between;">
            <span>Total original:</span>
            <span>${totalOriginal.toFixed(2)} DT</span>
          </div>
          ${discount > 0 ? `
            <div style="display:flex; justify-content:space-between; color:#d32f2f;">
              <span>Remise (${discount}%):</span>
              <span>-${discountAmount.toFixed(2)} DT</span>
            </div>
          ` : ''}
          
          <!-- AJOUT DES POINTS CADEAUX -->
          ${giftPointsTotal > 0 ? `
            <div style="display:flex; justify-content:space-between; margin-top:10px; background-color:#F3E5F5; padding:5px; border-radius:3px;">
              <span style="font-weight:bold; color:#7B1FA2;">🎁 Total Points Cadeaux:</span>
              <span style="font-weight:bold; color:#7B1FA2;">${giftPointsTotal} points</span>
            </div>
          ` : ''}
          
          <div style="display:flex; justify-content:space-between; font-weight:bold; margin-top:5px;">
            <span>Total à payer:</span>
            <span>${totalAfterDiscount.toFixed(2)} DT</span>
          </div>
          <div style="display:flex; justify-content:space-between; margin-top:5px;">
            <span>Mode de paiement:</span>
            <span>${paymentMethod}</span>
          </div>
          ${discount === 10 && discountCardNumber ? `
            <div style="margin-top:5px; font-size:0.9em; color:#4CAF50;">
              Réduction carte n°: ${discountCardNumber}
            </div>
          ` : ''}
        </div>
        
        <!-- SECTION QR CODE OPTIMISÉE POUR LE SCANNER HTML5 -->
        ${giftPointsTotal > 0 ? `
          <hr style="border:1px solid #7B1FA2; margin:15px 0;"/>
          <div style="text-align:center; margin:15px 0;">
            <h4 style="color:#7B1FA2; margin-bottom:10px;">🎁 Scannez pour ajouter ${giftPointsTotal} points</h4>
            
            <div style="display:flex; align-items:center; justify-content:center; gap:15px;">
              <!-- QR CODE COMPATIBLE HTML5 QR CODE SCANNER -->
              <div style="width:130px; height:130px; background-color:#FFFFFF; border:2px solid #7B1FA2; 
                  border-radius:8px; display:flex; justify-content:center; align-items:center; overflow:hidden; padding:8px;">
                <img 
                  src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(qrCodeText)}&color=7B1FA2&bgcolor=FFFFFF&margin=8&format=png&ecc=H&qzone=2"
                  alt="QR Code Points Cadeaux"
                  style="width:120px; height:120px; max-width:100%; border-radius:4px;"
                  onerror="this.onerror=null; this.src='https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=ERROR&color=FF0000&bgcolor=FFFFFF'"
                />
              </div>
              
             
                ${!qrCodeCreated ? `
                  <div style="margin-top:5px; font-size:10px; color:#ff9800; background:#fff3cd; padding:3px; border-radius:3px;">
                    ⚠️ Saisir manuellement: ${uniqueCode}
                  </div>
                ` : ''}
              </div>
            </div>
            
            <!-- INSTRUCTIONS DE SCAN -->
            <div style="margin-top:15px; text-align:left; background:#e8f5e9; padding:10px; border-radius:5px; font-size:11px; border:1px solid #4CAF50;">
              <p style="margin:0 0 5px 0; color:#2E7D32; font-weight:bold;">📱 Comment scanner:</p>
              <ol style="margin:0; padding-left:15px;">
                <li>Ouvrez l'application SPINTOSS Scanner</li>
                <li>Autorisez l'accès à la caméra</li>
                <li>Centrez le QR code dans le cadre</li>
                <li>Attendez la confirmation sonore</li>
                <li>Les points sont crédités automatiquement</li>
              </ol>
            </div>
            
            <!-- CODE DE FALLBACK POUR SCAN MANUEL -->
            <div style="margin-top:10px; padding:8px; background:#f5f5f5; border-radius:4px; font-size:10px;">
              <p style="margin:0 0 3px 0; color:#666;"><strong>En cas de problème de scan:</strong></p>
              <div style="font-family:monospace; background:white; padding:5px; border:1px dashed #ccc; border-radius:3px;">
                ${uniqueCode}
              </div>
              <p style="margin:3px 0 0 0; color:#999; font-size:9px;">
                Entrez ce code manuellement dans l'application
              </p>

            </div>
            <div style="margin-top:15px; font-size:20px; color:#666;">
          <p>Merci et à bientôt !</p>
          ${giftPointsTotal > 0 ? `
           
          ` : ''}
        </div>
          </div>
        ` : ''}
        
       
        
      </div>
    `;

    // Fonction d'impression
    const printWithFallback = async () => {
      try {
        const printWindow = window.open('', '', 'width=350,height=650,left=100,top=100');

        if (!printWindow) {
          // Fallback si popup bloqué
          const iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = 'none';
          document.body.appendChild(iframe);

          const iframeDoc = iframe.contentWindow.document;
          iframeDoc.open();
          iframeDoc.write(`
            <html>
              <head>
                <title>Addition - Facture ${nextBillNumber}</title>
                <style>
                  @media print {
                    body { margin: 0; padding: 10px; }
                    @page { size: auto; margin: 5mm; }
                  }
                  img { max-width: 100%; height: auto; }
                  pre { white-space: pre-wrap; word-wrap: break-word; }
                </style>
              </head>
              <body>
                ${printableContent}
                <script>
                  setTimeout(function() {
                    window.print();
                    setTimeout(function() {
                      document.body.removeChild(document.querySelector('iframe'));
                    }, 1000);
                  }, 500);
                </script>
              </body>
            </html>
          `);
          iframeDoc.close();

        } else {
          printWindow.document.write(`
            <html>
              <head>
                <title>Addition - Facture ${nextBillNumber}</title>
                <style>
                  @media print {
                    body { margin: 0; padding: 10px; }
                    @page { size: auto; margin: 5mm; }
                  }
                  img { max-width: 100%; height: auto; }
                  pre { white-space: pre-wrap; word-wrap: break-word; }
                </style>
              </head>
              <body onload="setTimeout(() => { window.print(); setTimeout(() => window.close(), 500); }, 500)">
                ${printableContent}
              </body>
            </html>
          `);
          printWindow.document.close();
        }
      } catch (printError) {
        console.error('❌ Erreur impression:', printError);
        // Fallback final
        const fallbackWindow = window.open();
        fallbackWindow.document.write(`
          <html>
            <head>
              <title>Addition - Facture ${nextBillNumber}</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 20px; max-width: 300px; margin: 0 auto; }
                button { padding: 10px 20px; background: #007bff; color: white; border: none; cursor: pointer; margin: 5px; }
                .buttons { margin-top: 20px; text-align: center; }
              </style>
            </head>
            <body>
              ${printableContent}
              <div class="buttons">
                <button onclick="window.print()">🖨️ Imprimer</button>
                <button onclick="window.close()">❌ Fermer</button>
              </div>
            </body>
          </html>
        `);
        fallbackWindow.document.close();
      }
    };

    // Appeler la fonction d'impression
    await printWithFallback();

    // Retourner l'info du QR code créé
    return {
      qrCodeText: uniqueCode,
      qrCodeCreated,
      serverQRCode,
      billNumber: nextBillNumber,
      qrCodeData: qrCodeText
    };
  };

  // Fonction pour créer un QR code rétroactivement
  const createRetroactiveQRCode = async (billNumber) => {
    try {
      const token = localStorage.getItem("token");

      // Rechercher la facture existante
      const billResponse = await axios.get(`/api/Bills/findBill`, {
        params: {
          billNumber: billNumber.padStart(3, '0'),
          billDate: new Date().toISOString().split('T')[0]
        },
        headers: { Authorised: token }
      });

      if (billResponse.data.success && billResponse.data.bill) {
        const bill = billResponse.data.bill;

        if (bill.giftPointsTotal > 0) {
          // Créer le QR code rétroactivement
          const qrData = {
            points: bill.giftPointsTotal,
            billNumber: bill.billNumber,
            location: bill.localisation?.name || "SPINTOSS",
            items: bill.items || [],
            totalAmount: bill.total || 0,
            qrType: "SPINTOSS_POINTS_RETROACTIVE",
            createdAt: bill.date || new Date().toISOString()
          };

          const qrResponse = await axios.post('/api/qr/create', qrData, {
            headers: {
              Authorised: token,
              'Content-Type': 'application/json'
            }
          });

          if (qrResponse.data.success) {
            console.log("✅ QR code rétroactif créé:", qrResponse.data.qrCode.code);
            return qrResponse.data.qrCode;
          }
        }
      }
    } catch (error) {
      console.error("❌ Erreur création QR rétroactif:", error);
    }
    return null;
  };

  // Fonction utilitaire pour vérifier si un QR code existe
  const checkQRCodeExists = async (code) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`/api/qr/check/${code}`, {
        headers: { Authorised: token }
      });
      return response.data.exists;
    } catch (error) {
      return false;
    }
  };

  const printPartialAddition = (partialItems) => {
    const locationConfig = getLocationConfig();
    const confirmationDate = new Date().toLocaleString();
    const staffInfo = isStaffAddition && selectedStaff ?
      staffList.find(s => s._id === selectedStaff) : null;

    // Calculer les points cadeaux pour le paiement partiel
    const partialPoints = calculateGiftPointsForPartial(partialItems);

    const printableContent = `
      <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
        <div style="text-align:center; margin-bottom:10px;">
          <img src="${locationConfig.logo}" alt="Logo ${locationConfig.name}" style="max-width:150px; max-height:50px;" onerror="this.style.display='none'" />
        </div>
        <h1 style="margin:0; font-size:18px;">${locationConfig.name}</h1>
        ${locationConfig.address ? `<p style="margin:5px 0; font-size:12px;">${locationConfig.address}</p>` : ''}
        <h3 style="margin:10px 0; color:#333;">Reçu de paiement partiel</h3>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <p style="margin:5px 0;"><strong>Facture N°:</strong> ${nextBillNumber}</p>
          <p style="margin:5px 0;"><strong>Date de confirmation:</strong> ${confirmationDate}</p>
          ${!isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Table:</strong> ${tableNumber}</p>` : ''}
          ${isFoodTrackMode ? `<p style="margin:5px 0;"><strong>Mode:</strong> Vente Directe</p>` : ''}
          ${staffInfo ? `
            <p style="margin:5px 0;"><strong>Addition Personnel:</strong> ${staffInfo.name} - ${staffInfo.matricule || staffInfo.employeeId || staffInfo.code || 'N/A'}</p>
          ` : ''}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          ${partialItems
        .map((item) => {
          // Calculer les points pour cet item
          let itemPoints = 0;
          if (!item.isDeal) {
            itemPoints = getSubProductPoints(item.id);
          }

          return `
                <div style="display:flex; justify-content:space-between; margin:5px 0;">
                  <span>${item.name} x${item.quantity}</span>
                  <span>${(item.price * item.quantity).toFixed(2)} DT</span>
                </div>
                ${item.isDeal && item.subProducts ? item.subProducts.map(sp =>
            `<div style="margin-left: 10px; font-size:0.9em; color:#666;">- ${sp.name}</div>`
          ).join('') : ''}
                ${item.promotion ? `<div style="margin-left: 10px; font-size:0.8em; color:#4CAF50;">Promo: ${item.promotion.promotionName} -${item.promotion.discount}%</div>` : ''}
                ${itemPoints > 0 ? `<div style="margin-left: 10px; font-size:0.8em; color:#9C27B0;">Points cadeaux: ${itemPoints * item.quantity} pts</div>` : ''}
              `;
        })
        .join("")}
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <div style="display:flex; justify-content:space-between; font-weight:bold;">
            <span>Total partiel:</span>
            <span>${calculatePartialTotal()} DT</span>
          </div>
          
          <!-- AJOUT DES POINTS CADEAUX POUR LE PAIEMENT PARTIEL -->
          ${partialPoints > 0 ? `
            <div style="display:flex; justify-content:space-between; margin-top:10px; background-color:#F3E5F5; padding:5px; border-radius:3px;">
              <span style="font-weight:bold; color:#7B1FA2;">🎁 Points Cadeaux Partiels:</span>
              <span style="font-weight:bold; color:#7B1FA2;">${partialPoints} points</span>
            </div>
          ` : ''}
          
          <div style="display:flex; justify-content:space-between; margin-top:5px;">
            <span>Mode de paiement:</span>
            <span>${paymentMethod}</span>
          </div>
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="margin-top:15px; font-size:12px; color:#666;">
          <p>Merci pour votre paiement !</p>
        </div>
      </div>
    `;
    printContent(printableContent);
  };

  const printContent = async (content) => {
    const printWindow = window.open('', '', 'width=350,height=600,left=100,top=100');

    // Attendre que le contenu soit complètement chargé
    await new Promise(resolve => {
      printWindow.document.write(`
        <html>
          <head>
            <title>Addition - ${isFoodTrackMode ? 'Vente Directe' : `Table ${tableNumber}`}</title>
            <style>
              @media print {
                body { margin: 0; padding: 10px; }
                @page { size: auto; margin: 5mm; }
              }
              img { max-width: 100%; height: auto; }
            </style>
          </head>
          <body onload="window.print(); setTimeout(() => window.close(), 500);">
            ${content}
          </body>
        </html>
      `);
      printWindow.document.close();

      // Attendre que les images soient chargées
      printWindow.onload = resolve;
    });
  };

  // ========================================
  // MODIFICATION: Réductions avec validation via config
  // ========================================
  const applyDiscount = (percentage) => {
    if (isStaffAddition) {
      alert("Impossible d'appliquer une réduction supplémentaire en mode personnel");
      return;
    }
    setDiscount(percentage);
  };

  const validateDiscountCode = () => {
    if (isStaffAddition) {
      alert("Impossible d'appliquer un code de réduction en mode personnel");
      return;
    }

    // Validation via le système de paramétrage
    const validationResult = ConfigurationManager.validateDiscountCode(discountCode);

    if (validationResult.valid) {
      setDiscount(validationResult.discount);
      alert(validationResult.message);
    } else {
      alert(validationResult.message || "Code invalide.");
    }
  };

  // ========================================
  // FONCTION CORRIGÉE : Appliquer la réduction de 10% via carte
  // ========================================
  const apply10PercentCardDiscount = async () => {
    // 1. Demander le numéro de carte
    const cardNumber = prompt("Numéro de carte (ex: CARD08610580780) :", "");

    if (!cardNumber || !cardNumber.trim()) {
      // Si pas d'input ou vide, annuler
      return;
    }

    try {
      setLoading(true);

      // 2. Valider la carte via l'API
      const validation = await validateDiscountCard(cardNumber.trim());

      // 3. Vérifier si la validation a réussi et que la carte donne 10%
      if (validation.success) {
        if (validation.card.discountPercentage === 10) {
          // 4. Appliquer la réduction
          setDiscount(10);
          setDiscountCardNumber(cardNumber.trim());

          // 5. Afficher message SUCCÈS
          const successDiv = document.createElement('div');
          successDiv.innerHTML = `
            <div style="
              background: #d4edda;
              color: #155724;
              padding: 10px;
              margin: 10px 0;
              border-radius: 5px;
              border: 1px solid #c3e6cb;
            ">
              ✅ Carte validée : ${validation.card.owner} - 10% appliqué
            </div>
          `;

          // Insérer dans la page
          const discountSection = document.querySelector('.discount-section');
          if (discountSection) {
            discountSection.appendChild(successDiv);
          }

          // Retirer après 5 secondes
          setTimeout(() => successDiv.remove(), 5000);

          console.log(`✅ Carte ${cardNumber} validée - 10% appliqué`);

        } else {
          // Carte valide mais pas à 10%
          const errorDiv = document.createElement('div');
          errorDiv.innerHTML = `
            <div style="
              background: #fff3cd;
              color: #856404;
              padding: 10px;
              margin: 10px 0;
              border-radius: 5px;
              border: 1px solid #ffeaa7;
            ">
              ⚠️ Cette carte donne ${validation.card.discountPercentage}% (pas 10%)
            </div>
          `;

          const discountSection = document.querySelector('.discount-section');
          if (discountSection) {
            discountSection.appendChild(errorDiv);
          }

          setTimeout(() => errorDiv.remove(), 5000);

          alert(`Cette carte donne ${validation.card.discountPercentage}%, pas 10%`);
        }
      } else {
        // Validation échouée
        const errorDiv = document.createElement('div');
        errorDiv.innerHTML = `
          <div style="
            background: #f8d7da;
            color: #721c24;
            padding: 10px;
            margin: 10px 0;
            border-radius: 5px;
            border: 1px solid #f5c6cb;
          ">
            ❌ ${validation.message || "Code non valide"}
          </div>
        `;

        const discountSection = document.querySelector('.discount-section');
        if (discountSection) {
          discountSection.appendChild(errorDiv);
        }

        setTimeout(() => errorDiv.remove(), 5000);

        alert(validation.message || "Code de carte invalide");
      }
    } catch (error) {
      console.error("Erreur lors de la validation de la carte:", error);
      alert("Erreur technique lors de la validation de la carte");
    } finally {
      setLoading(false);
    }
  };

  // ========================================
  // FONCTIONS POUR L'ANNULATION
  // ========================================
  const fetchBillsHistory = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/Bills/getAllBills", {
        headers: { Authorised: token }
      });
      setBillsHistory(response.data);
    } catch (error) {
      console.error("Erreur lors du chargement des factures:", error);
    }
  };

  // Fonction pour rechercher une facture
  const searchBill = async () => {
    if (!invoiceDate || !invoiceNumber) {
      alert("Veuillez saisir la date et le numéro de facture");
      return;
    }

    setSearchLoading(true);
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(`/api/Bills/findBill`, {
        params: {
          billDate: invoiceDate,
          billNumber: invoiceNumber.padStart(3, '0')
        },
        headers: {
          Authorised: token,
          'Content-Type': 'application/json'
        }
      });

      if (response.data && response.data.success) {
        setFoundBill(response.data.bill);
        alert(`Facture trouvée: ${response.data.bill.billNumber} du ${new Date(response.data.bill.date).toLocaleDateString()}`);
      } else {
        setFoundBill(null);
        alert("Facture non trouvée");
      }
    } catch (error) {
      console.error("Erreur recherche facture:", error);

      if (error.response?.status === 404) {
        alert(`Aucune facture trouvée pour le numéro ${invoiceNumber} à la date ${invoiceDate}`);
      } else if (error.response?.data?.message) {
        alert(`Erreur: ${error.response.data.message}`);
      } else {
        alert("Erreur lors de la recherche de la facture");
      }
      setFoundBill(null);
    } finally {
      setSearchLoading(false);
    }
  };

  // Fonction pour ouvrir le modal d'annulation
  const openCancelModal = () => {
    // Vérifier si l'annulation est activée
    if (!config?.features?.cancellation?.enabled) {
      alert("L'annulation d'articles est désactivée");
      return;
    }

    setShowCancelModal(true);
    setAdminCode("");
    setCancelBarcodeInput("");
    setInvoiceNumber("");
    setInvoiceDate("");
    setCancelReason("");
    setFoundBill(null);
  };

  // FONCTION D'ANNULATION D'ARTICLE
  const cancelArticle = async () => {
    if (!adminCode.trim()) {
      alert("Veuillez saisir le code administrateur");
      return;
    }

    if (!ADMIN_CODES.includes(adminCode)) {
      alert("Code administrateur invalide");
      return;
    }

    if (!foundBill) {
      alert("Veuillez d'abord trouver la facture");
      return;
    }

    if (!cancelBarcodeInput.trim()) {
      alert("Veuillez sélectionner un article");
      return;
    }

    if (!cancelReason.trim()) {
      alert("Veuillez sélectionner un motif d'annulation");
      return;
    }

    try {
      setLoading(true);

      const articleToCancel = foundBill.items.find(item =>
        item._id.toString() === cancelBarcodeInput
      );

      if (!articleToCancel) {
        alert("Article non trouvé dans la facture");
        return;
      }

      let productId = null;

      if (articleToCancel.id) {
        if (typeof articleToCancel.id === 'object') {
          productId = articleToCancel.id._id || articleToCancel.id.$oid || articleToCancel.id.toString();
        } else if (typeof articleToCancel.id === 'string') {
          productId = articleToCancel.id;
        }
      }

      if (!productId && articleToCancel.name) {
        productId = findProductId(articleToCancel.name);
      }

      if (!productId) {
        const manualId = prompt(
          `ID non trouvé pour "${articleToCancel.name}".\n\nVeuillez saisir l'ID manuellement:`,
          ""
        );

        if (manualId && manualId.trim()) {
          productId = manualId.trim();
        } else {
          alert("Annulation impossible sans ID produit");
          return;
        }
      }

      // Vérifier si la restauration de stock est activée
      if (config?.features?.cancellation?.allowStockRestoration) {
        const stockRestored = await restoreStock(productId, articleToCancel.quantity);

        if (!stockRestored) {
          console.warn("Problème lors de la restauration du stock");
        }
      }

      const token = localStorage.getItem("token");

      const response = await axios.put('/api/Bills/cancelArticle', {
        billId: foundBill._id,
        barcode: productId,
        cancelReason: cancelReason
      }, {
        headers: {
          Authorised: token,
          'Content-Type': 'application/json'
        }
      });

      if (response.data && response.data.success) {
        alert(`Article annulé: ${response.data.cancelledArticle}`);
        printCancelReceipt(response.data.cancelledArticle);

        setShowCancelModal(false);
        setFoundBill(null);
        setInvoiceDate("");
        setInvoiceNumber("");
        setCancelBarcodeInput("");
        setCancelReason("");
        setAdminCode("");

        fetchBillsHistory();
      } else {
        alert("Erreur lors de l'annulation: " + (response.data.message || "Erreur inconnue"));
      }

    } catch (error) {
      console.error("Erreur lors de l'annulation:", error);

      if (error.response?.status === 404) {
        alert("Erreur: Article non trouvé dans la facture. " + (error.response.data?.message || ""));
      } else if (error.response?.data?.message) {
        alert("Erreur: " + error.response.data.message);
      } else {
        alert("Erreur lors de l'annulation de l'article");
      }
    } finally {
      setLoading(false);
    }
  };

  const printCancelReceipt = (articleName) => {
    const locationConfig = getLocationConfig();
    const cancellationDate = new Date().toLocaleString();

    const printableContent = `
      <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
        <div style="text-align:center; margin-bottom:10px;">
          <img src="${locationConfig.logo}" alt="Logo ${locationConfig.name}" style="max-width:150px; max-height:50px;" onerror="this.style.display='none'" />
        </div>
        <h1 style="margin:0; font-size:18px;">${locationConfig.name}</h1>
        ${locationConfig.address ? `<p style="margin:5px 0; font-size:12px;">${locationConfig.address}</p>` : ''}
        <h3 style="color:red; margin:10px 0;">AVIS D'ANNULATION</h3>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <p style="margin:5px 0;"><strong>Facture annulée:</strong> ${foundBill.billNumber}</p>
          <p style="margin:5px 0;"><strong>Date d'achat:</strong> ${new Date(foundBill.date).toLocaleDateString()}</p>
          <p style="margin:5px 0;"><strong>Article annulé:</strong> ${articleName}</p>
          <p style="margin:5px 0;"><strong>Motif:</strong> ${cancelReason}</p>
          <p style="margin:5px 0;"><strong>Annulé par:</strong> Administrateur</p>
          <p style="margin:5px 0;"><strong>Date d'annulation:</strong> ${cancellationDate}</p>
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="color:red; font-weight:bold; margin:10px 0;">
          ARTICLE ANNULÉ - ${config?.features?.cancellation?.allowStockRestoration ? 'STOCK RESTAURÉ' : 'STOCK NON RESTAURÉ'}
        </div>
        <div style="margin-top:20px; font-size:12px;">
          Merci de votre confiance
        </div>
      </div>
    `;

    const printWindow = window.open('', '', 'width=350,height=500,left=100,top=100');
    printWindow.document.write(`
      <html>
        <head>
          <title>Annulation Facture ${foundBill.billNumber}</title>
        </head>
        <body>
          ${printableContent}
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ========================================
  // RENDU DES COMPOSANTS AVEC CONDITIONS
  // ========================================

  // Rendu des catégories
  const renderCategoryButtons = () => (
    <div className="catego-buttons" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
      {availableCategories.map(category => (
        <button
          key={category}
          className={`catego-button ${selectedCategory === category ? "active" : ""}`}
          onClick={() => {
            setSelectedCategory(category);
            setSelectedProduct(null);
          }}
          style={{ flex: '0 0 calc(25% - 10px)' }}
        >
          {category}
        </button>
      ))}
    </div>
  );

  const renderProducts = () => {
    if (!selectedCategory) return null;

    if (selectedProduct) {
      return renderSubProducts();
    } else {
      return renderMainProducts();
    }
  };

  const renderMainProducts = () => {
    const productRows = [];
    for (let i = 0; i < filteredProducts.length; i += 6) {
      productRows.push(filteredProducts.slice(i, i + 6));
    }

    return productRows.map((row, rowIndex) => (
      <div key={rowIndex} className="product-row">
        {row.map((product) => {
          const accessibleSubProducts = getProductSubProducts(product._id);
          const hasAccessibleSubProducts = accessibleSubProducts.length > 0;

          return (
            <button
              key={product._id}
              className="product-button"
              onClick={() => toggleSubProducts(product._id)}
              disabled={!hasAccessibleSubProducts}
              title={!hasAccessibleSubProducts ? "Aucun sous-produit disponible dans votre localisation" : ""}
            >
              {product.name}
              {!hasAccessibleSubProducts && " ❌"}
            </button>
          );
        })}
      </div>
    ));
  };

  const renderSubProducts = () => {
    const subProducts = getProductSubProducts(selectedProduct);

    if (subProducts.length === 0) {
      return (
        <div className="no-subproducts">
          Aucun sous-produit disponible dans votre localisation
        </div>
      );
    }

    const rows = [];
    for (let i = 0; i < subProducts.length; i += 7) {
      rows.push(subProducts.slice(i, i + 7));
    }

    return (
      <div className="sub-product-container">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="sub-product-row">
            {row.map((subProduct) => (
              <button
                key={`${selectedProduct}-${subProduct._id}`}
                className="sub-product-button"
                onClick={() =>
                  handleSubProductClick(
                    subProduct._id,
                    subProduct.name,
                    subProduct.price,
                    selectedProduct
                  )
                }
              >
                {subProduct.name}
                {subProduct.promotion && <span style={{ color: '#4CAF50', fontSize: '0.8em' }}> -{subProduct.promotion.discount}%</span>}
                {/* Afficher les points cadeaux si disponibles */}
                {subProduct.giftPoints > 0 && (
                  <span style={{ color: '#9C27B0', fontSize: '0.7em', marginLeft: '5px' }}>
                    🎁 {subProduct.giftPoints} pts
                  </span>
                )}
              </button>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const renderAdditionTable = () => (
    <table className="addition-table">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Prix</th>
          <th>Quantité</th>
          <th>Total</th>
          <th>Points</th> {/* ← NOUVELLE COLONNE */}
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {additionItems.map((item) => {
          // Calculer les points pour cet item
          let itemPoints = 0;

          if (!item.isDeal) {
            itemPoints = getSubProductPoints(item.id);
          }

          return (
            <tr key={item.id}>
              <td>
                {item.name}
                {item.promotion && (
                  <div style={{ fontSize: '0.8em', color: '#4CAF50', fontWeight: 'bold' }}>
                    Promo: ${item.promotion.promotionName} (-${item.promotion.discount}%)
                  </div>
                )}
                {item.isDeal && item.subProducts && (
                  <div style={{ marginLeft: '15px', fontSize: '0.9em', color: '#666' }}>
                    {item.subProducts.map(sp => `• ${sp.name}`).join(', ')}
                  </div>
                )}
              </td>
              <td>${item.price.toFixed(2)} DT</td>
              <td>
                <input
                  type="number"
                  value={item.quantity}
                  onChange={(e) => modifyItem(item.id, parseInt(e.target.value))}
                  style={{ width: "50px" }}
                  min="1"
                />
              </td>
              <td>${(item.price * item.quantity).toFixed(2)} DT</td>
              <td style={{
                color: '#9C27B0',
                fontWeight: 'bold',
                textAlign: 'center'
              }}>
                {item.isDeal ?
                  (() => {
                    let dealPoints = 0;
                    if (item.subProducts) {
                      item.subProducts.forEach(sp => {
                        dealPoints += getSubProductPoints(sp.id);
                      });
                    }
                    return dealPoints > 0 ? `${dealPoints} pts` : '—';
                  })()
                  : `${itemPoints * item.quantity} pts`}
              </td>
              <td>
                <button onClick={() => deleteItem(item.id)}>X</button>
              </td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        {/* AJOUTEZ CETTE LIGNE POUR LE TOTAL DES POINTS */}
        {giftPointsTotal > 0 && (
          <tr style={{ backgroundColor: '#F3E5F5', color: '#7B1FA2' }}>
            <td colSpan="4" style={{ fontWeight: 'bold' }}>🎁 Total Points Cadeaux</td>
            <td colSpan="2" style={{ fontWeight: 'bold', textAlign: 'center' }}>
              ${giftPointsTotal} points
              <button
                onClick={openQRCodeModal}
                style={{
                  marginLeft: '10px',
                  backgroundColor: '#7B1FA2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '3px',
                  padding: '2px 8px',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >
                QR Code
              </button>
            </td>
          </tr>
        )}

        <tr>
          <td colSpan="4">Total HT</td>
          <td colSpan="2">${totalHT} DT</td>
        </tr>
        <tr>
          <td colSpan="4">TVA</td>
          <td colSpan="2">${tva} DT</td>
        </tr>
        <tr>
          <td colSpan="4">Total TTC</td>
          <td colSpan="2">${totalTTC} DT</td>
        </tr>
        {isStaffAddition && (
          <tr style={{ backgroundColor: '#fff3e0' }}>
            <td colSpan="4" style={{ color: '#ff9800', fontWeight: 'bold' }}>Réduction Personnel (${config?.features?.staff?.discountPercentage || 20}%)</td>
            <td colSpan="2" style={{ color: '#ff9800', fontWeight: 'bold' }}>-${(additionItems.reduce((sum, item) => sum + item.price * item.quantity, 0) * (config?.features?.staff?.discountPercentage || 20) / 100).toFixed(2)} DT</td>
          </tr>
        )}
      </tfoot>
    </table>
  );

  // Rendu des méthodes de paiement dans le popup seulement
  const renderPaymentMethods = () => (
    <div className="payment-buttons">
      {getPaymentMethods().map((method) => (
        <button
          key={method}
          onClick={() => setPaymentMethod(method)}
          className={paymentMethod === method ? "selected" : ""}
        >
          ${method}
        </button>
      ))}
    </div>
  );

  // POPUP DE PAIEMENT SIMPLIFIÉ
  const renderPaymentModal = () => (
    showPaymentModal && (
      <div className="modal-overlay payment-modal-overlay">
        <div className="modal-content payment-modal-content">
          <div className="modal-header payment-modal-header">
            <h3>Sélection du Mode de Paiement</h3>
            <button
              className="close-modal payment-close-modal"
              onClick={() => {
                setShowPaymentModal(false);
                setPaymentMethod(null);
              }}
            >
              ✕
            </button>
          </div>

          <div className="modal-body payment-modal-body">
            <div className="payment-info-basic">
              {!isFoodTrackMode && (
                <div className="info-row">
                  <span className="info-label">Table:</span>
                  <span className="info-value">${tableNumber}</span>
                </div>
              )}
              <div className="info-row">
                <span className="info-label">Total à payer:</span>
                <span className="info-value total-amount">${totalTTC} DT</span>
              </div>
              {giftPointsTotal > 0 && (
                <div className="info-row" style={{ color: '#7B1FA2' }}>
                  <span className="info-label">Points cadeaux:</span>
                  <span className="info-value">🎁 ${giftPointsTotal} points</span>
                </div>
              )}
              {clientName && (
                <div className="info-row" style={{ color: '#2E7D32', fontWeight: 'bold', marginTop: '5px' }}>
                  <span className="info-label">Client identifié:</span>
                  <span className="info-value">✅ ${clientName}</span>
                </div>
              )}
              {isFoodTrackMode && (
                <div className="info-row">
                  <span className="info-label">Mode:</span>
                  <span className="info-value">Vente Directe</span>
                </div>
              )}
              {isStaffAddition && (
                <div className="staff-info-badge">
                  Addition Personnel -${config?.features?.staff?.discountPercentage || 20}%
                </div>
              )}
            </div>

            <div className="payment-methods-section">
              <h4 className="methods-title">Choisissez le mode de paiement :</h4>
              <div className="payment-methods-grid">
                {getPaymentMethods().map((method) => (
                  <button
                    key={method}
                    onClick={() => setPaymentMethod(method)}
                    className={`payment-method-btn ${paymentMethod === method ? "selected" : ""}`}
                  >
                    ${method}
                  </button>
                ))}
              </div>
            </div>

            {paymentMethod && (
              <div className="selected-payment-confirmation">
                <div className="selected-method">
                  <span className="selected-label">Mode sélectionné :</span>
                  <span className="selected-value">${paymentMethod}</span>
                </div>
              </div>
            )}
          </div>

          <div className="modal-actions payment-modal-actions">
            <button
              onClick={confirmPaymentFromModal}
              disabled={!paymentMethod || loading}
              className="confirm-payment-btn"
            >
              ${loading ? (
                <>
                  <span className="loading-spinner"></span>
                  Traitement en cours...
                </>
              ) : (
                <>
                  <span className="confirm-icon">✅</span>
                  Confirmer le Paiement
                </>
              )}
            </button>
            <button
              onClick={() => {
                setShowPaymentModal(false);
                setPaymentMethod(null);
              }}
              className="cancel-payment-btn"
            >
              <span className="cancel-icon">❌</span>
              Annuler
            </button>
          </div>
        </div>
      </div>
    )
  );

  // MODAL POUR L'ADDITION PERSONNEL
  const renderStaffModal = () => (
    showStaffModal && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Addition Personnel</h3>
            <button
              className="close-modal"
              onClick={() => {
                setShowStaffModal(false);
                setSelectedStaff("");
              }}
            >
              ✕
            </button>
          </div>

          <div className="modal-body">
            <div className="staff-selection">
              <label>Sélectionnez le membre du personnel:</label>
              <select
                value={selectedStaff}
                onChange={(e) => handleStaffSelect(e.target.value)}
                className="staff-select"
              >
                <option value="">-- Choisissez un employé --</option>
                ${filteredStaffList.map((staff) => (
                  <option key={staff._id} value={staff._id}>
                    ${staff.name} - ${staff.matricule || staff.employeeId || staff.code || 'N/A'}
                    ${staff.localisation && ` (${staff.localisation.name || staff.localisation})`}
                  </option>
                ))}
              </select>

              <div style={{
                marginTop: '10px',
                fontSize: '12px',
                color: '#666'
              }}>
                ${filteredStaffList.length === 0 ? (
                  <span style={{ color: '#f44336' }}>
                    Aucun employé trouvé pour votre localisation
                  </span>
                ) : (
                  <span style={{ color: '#4caf50' }}>
                    ${filteredStaffList.length} employé(s) disponible(s)
                  </span>
                )}
              </div>
            </div>

            ${selectedStaff && (
              // ... continuation depuis le code coupé

              <div className="staff-info" style={{
                backgroundColor: '#e8f5e8',
                padding: '10px',
                borderRadius: '5px',
                marginTop: '10px',
                border: '1px solid #4caf50'
              }}>
                <strong>Informations sélectionnées:</strong><br />
                <span>Nom: {staffList.find(s => s._id === selectedStaff)?.name}</span><br />
                <span>Matricule: {staffList.find(s => s._id === selectedStaff)?.matricule || staffList.find(s => s._id === selectedStaff)?.employeeId || staffList.find(s => s._id === selectedStaff)?.code || 'N/A'}</span><br />
                <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>Réduction: {config?.features?.staff?.discountPercentage || 20}% appliquée sur tous les articles</span>
              </div>
            )}

            <div className="staff-discount-info" style={{
              backgroundColor: '#fff3cd',
              padding: '10px',
              borderRadius: '5px',
              marginTop: '15px',
              border: '1px solid #ffc107'
            }}>
              <strong>Information:</strong>
              <p>Une réduction de {config?.features?.staff?.discountPercentage || 20}% sera appliquée sur tous les articles de l'addition.</p>
            </div>
          </div>

          <div className="modal-actions">
            <button
              onClick={confirmStaffAddition}
              disabled={!selectedStaff || filteredStaffList.length === 0}
              className="confirm-button"
              style={{
                backgroundColor: '#4caf50',
                color: 'white'
              }}
            >
              Confirmer l'Addition Personnel
            </button>
            <button
              onClick={() => {
                setShowStaffModal(false);
                setSelectedStaff("");
              }}
              className="cancel-button"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    )
  );

  // MODAL POUR LE PAIEMENT COMBINÉ
  const renderCombinedPaymentModal = () => (
    showCombinedPayment && (
      <div className="modal-overlay" style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center',
        alignItems: 'center', zIndex: 2000
      }}>
        <div className="modal-content" style={{
          backgroundColor: 'white', padding: '16px', borderRadius: '10px',
          maxWidth: '900px', width: '114%', maxHeight: '92vh', overflowY: 'auto'
        }}>
          <div className="modal-header" style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px'
          }}>
            <h3 style={{ margin: 0, color: '#f5f0f0ff' }}>Paiement Combiné</h3>
            <button
              onClick={() => {
                setShowCombinedPayment(false);
                setCombinedPayments([]);
              }}
              style={{
                background: 'none', border: 'none', fontSize: '24px',
                cursor: 'pointer', color: '#999'
              }}
            >
              ✕
            </button>
          </div>

          <div className="payment-info" style={{
            backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px',
            marginBottom: '20px', border: '1px solid #dee2e6'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
              {!isFoodTrackMode && (
                <>
                  <span style={{ fontWeight: 'bold' }}>Table:</span>
                  <span>{tableNumber}</span>
                </>
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
              <span style={{ fontWeight: 'bold' }}>Total à payer:</span>
              <span style={{ fontWeight: 'bold', color: '#28a745' }}>{totalTTC} DT</span>
            </div>
            {giftPointsTotal > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                <span style={{ fontWeight: 'bold', color: '#7B1FA2' }}>Points cadeaux:</span>
                <span style={{ fontWeight: 'bold', color: '#7B1FA2' }}>🎁 {giftPointsTotal} points</span>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <span style={{ fontWeight: 'bold' }}>Montant restant:</span>
              <span style={{ fontWeight: 'bold', color: remainingAmount > 0 ? '#dc3545' : '#28a745' }}>
                {remainingAmount.toFixed(2)} DT
              </span>
            </div>
          </div>




          <div className="payment-input-section" style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
              {/* BOUTONS DE PAIEMENT AMÉLIORÉS */}
              <div style={{
                flex: '1',
                minWidth: '250px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
              }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
                  gap: '8px'
                }}>
                  {getPaymentMethods().map(method => (
                    <button
                      key={method}
                      onClick={() => setCombinedPaymentMethod(method)}
                      style={{
                        padding: '12px 6px',
                        backgroundColor: combinedPaymentMethod === method ? '#28a745' : 'white',
                        color: combinedPaymentMethod === method ? 'white' : '#495057',
                        border: combinedPaymentMethod === method ? 'none' : '1px solid #dee2e6',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '50px',
                        boxShadow: combinedPaymentMethod === method
                          ? '0 4px 12px rgba(40, 167, 69, 0.25)'
                          : '0 2px 4px rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                        overflow: 'auto'
                      }}
                      className="payment-method-button"
                      onMouseEnter={(e) => {
                        if (combinedPaymentMethod !== method) {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (combinedPaymentMethod !== method) {
                          e.currentTarget.style.backgroundColor = 'white';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                        }
                      }}
                    >
                      {method}
                      {combinedPaymentMethod === method && (
                        <span style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          fontSize: '10px',
                          background: 'rgba(255, 255, 255, 0.2)',
                          width: '16px',
                          height: '16px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          ✓
                        </span>
                      )}
                    </button>
                  ))}
                </div>

                <div style={{
                  fontSize: '12px',
                  color: '#6c757d',
                  textAlign: 'center',
                  padding: '8px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '6px',
                  borderLeft: '3px solid #28a745',
                  marginTop: '5px'
                }}>
                  Sélectionnez un mode de paiement
                </div>
              </div>

              {/* ZONE DE SAISIE DU MONTANT */}
              <div style={{
                flex: '1',
                minWidth: '200px',
                position: 'relative'
              }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#495057',
                  marginBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}>
                  <span>💳</span>
                  <span>Montant à payer</span>
                </div>

                <div style={{
                  position: 'relative',
                  borderRadius: '10px',
                  overflow: 'auto',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  border: '2px solid #e9ecef',
                  transition: 'border-color 0.2s'
                }}>
                  <input
                    type="text"
                    value={combinedPaymentAmount}
                    readOnly
                    placeholder="0.00"
                    style={{
                      width: '100%',
                      padding: '16px 50px 16px 20px',
                      borderRadius: '8px',
                      border: 'none',
                      fontSize: '24px',
                      fontWeight: '700',
                      textAlign: 'right',
                      background: 'white',
                      color: '#212529',
                      fontFamily: "'Courier New', monospace",
                      outline: 'none'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#28a745',
                    fontWeight: 'bold',
                    fontSize: '18px',
                    background: 'rgba(40, 167, 69, 0.1)',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}>
                    DT
                  </div>
                </div>

                {combinedPaymentAmount && (
                  <div style={{
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#28a745',
                    textAlign: 'right',
                    fontWeight: '600'
                  }}>
                    {parseFloat(combinedPaymentAmount || 0).toFixed(2)} DT
                  </div>
                )}
              </div>
            </div>

            {/* CLAVIER NUMÉRIQUE AMÉLIORÉ */}
            <div className="numeric-keypad" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '12px',
              marginBottom: '20px',
              backgroundColor: '#f8f9fa',
              padding: '15px',
              borderRadius: '12px',
              border: '1px solid #dee2e6'
            }}>
              {['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'DEL'].map((key) => (
                <button
                  key={key}
                  onClick={() => handleNumericInput(key)}
                  style={{
                    padding: '18px 10px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    border: '1px solid #ced4da',
                    borderRadius: '10px',
                    backgroundColor: key === 'DEL' ? '#dc3545' : 'white',
                    color: key === 'DEL' ? 'white' : '#495057',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = key === 'DEL'
                      ? '0 4px 12px rgba(220, 53, 69, 0.25)'
                      : '0 4px 12px rgba(0, 0, 0, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                  }}
                >
                  {key}
                </button>
              ))}
            </div>

            {/* BOUTON AJOUTER PAIEMENT */}
            <button
              onClick={addCombinedPayment}
              disabled={!combinedPaymentAmount || parseFloat(combinedPaymentAmount) <= 0}
              style={{
                width: '100%',
                padding: '16px',
                background: !combinedPaymentAmount || parseFloat(combinedPaymentAmount) <= 0
                  ? 'linear-gradient(135deg, #6c757d, #495057)'
                  : 'linear-gradient(135deg, #28a745, #20c997)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: '700',
                cursor: !combinedPaymentAmount || parseFloat(combinedPaymentAmount) <= 0 ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: !combinedPaymentAmount || parseFloat(combinedPaymentAmount) <= 0
                  ? 'none'
                  : '0 4px 15px rgba(40, 167, 69, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                opacity: !combinedPaymentAmount || parseFloat(combinedPaymentAmount) <= 0 ? 0.6 : 1
              }}
              onMouseEnter={(e) => {
                if (combinedPaymentAmount && parseFloat(combinedPaymentAmount) > 0) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(40, 167, 69, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (combinedPaymentAmount && parseFloat(combinedPaymentAmount) > 0) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(40, 167, 69, 0.3)';
                }
              }}
            >
              <span style={{ fontSize: '18px' }}>➕</span>
              <span>Ajouter ce Paiement de {combinedPaymentAmount ? parseFloat(combinedPaymentAmount).toFixed(2) : '0.00'} DT</span>
            </button>
          </div>



          {combinedPayments.length > 0 && (
            <div className="payments-list" style={{ marginBottom: '20px' }}>
              <h4 style={{ marginBottom: '10px', color: '#333' }}>Paiements ajoutés:</h4>
              <div style={{
                maxHeight: '200px', overflowY: 'auto',
                border: '1px solid #dee2e6', borderRadius: '5px'
              }}>
                {combinedPayments.map((payment, index) => (
                  <div key={index} style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', padding: '10px',
                    borderBottom: '1px solid #eee',
                    backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
                  }}>
                    <div>
                      <span style={{ fontWeight: 'bold' }}>{payment.method}</span>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {payment.timestamp}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {payment.amount.toFixed(2)} DT
                      </span>
                      <button
                        onClick={() => removeCombinedPayment(index)}
                        style={{
                          backgroundColor: '#dc3545', color: 'white',
                          border: 'none', borderRadius: '3px',
                          width: '30px', height: '30px',
                          cursor: 'pointer', fontSize: '14px'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{
                display: 'flex', justifyContent: 'space-between',
                padding: '10px', backgroundColor: '#e9ecef',
                borderRadius: '0 0 5px 5px', fontWeight: 'bold'
              }}>
                <span>Total payé:</span>
                <span>{combinedPayments.reduce((sum, payment) => sum + payment.amount, 0).toFixed(2)} DT</span>
              </div>
            </div>
          )}

          <div className="modal-actions" style={{
            display: 'flex', gap: '10px', justifyContent: 'space-between'
          }}>
            <button
              onClick={() => {
                setShowCombinedPayment(false);
                setCombinedPayments([]);
              }}
              style={{
                flex: 1, padding: '12px', backgroundColor: '#6c757d',
                color: 'white', border: 'none', borderRadius: '5px',
                fontSize: '16px', fontWeight: 'bold', cursor: 'pointer'
              }}
            >
              Annuler
            </button>

            <button
              onClick={confirmCombinedPayment}
              disabled={combinedPayments.length === 0 || remainingAmount > 0.01}
              style={{
                flex: 2, padding: '12px', backgroundColor: remainingAmount > 0.01 ? '#6c757d' : '#28a745',
                color: 'white', border: 'none', borderRadius: '5px',
                fontSize: '16px', fontWeight: 'bold', cursor: 'pointer'
              }}
            >
              {loading ? (
                <>
                  <span className="loading-spinner"></span>
                  Traitement...
                </>
              ) : remainingAmount > 0.01 ? (
                `Ajouter ${remainingAmount.toFixed(2)} DT`
              ) : (
                'Confirmer le Paiement'
              )}
            </button>
          </div>
        </div>
      </div>
    )
  );

  // ========================================
  // MODAL POUR LE QR CODE DES POINTS CADEAUX (avec vrai QR Code)
  // ========================================
  const renderQRCodeModal = () => {
    if (!showQRCodeModal) return null;

    // Créer le texte formaté pour le QR Code
    const qrCodeData = JSON.stringify({
      type: "SPINTOSS_POINTS",
      billNumber: nextBillNumber,
      points: giftPointsTotal,
      code: `Kdo${giftPointsTotal}`,
      table: !isFoodTrackMode ? tableNumber : "VENTE_DIRECTE",
      date: new Date().toISOString(),
      location: currentUser?.localisation?.name || "SPINTOSS",
      items: giftPointsDetails.map(item => ({
        name: item.name,
        points: item.totalPoints
      }))
    });

    return (
      <div className="modal-overlay" style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center',
        alignItems: 'center', zIndex: 2000
      }}>
        <div className="modal-content" style={{
          backgroundColor: 'white', padding: '20px', borderRadius: '10px',
          maxWidth: '400px', width: '90%', textAlign: 'center'
        }}>
          <div className="modal-header" style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px'
          }}>
            <h3 style={{ margin: 0, color: '#7B1FA2' }}>🎁 QR Code Points Cadeaux</h3>
            <button
              onClick={() => setShowQRCodeModal(false)}
              style={{
                background: 'none', border: 'none', fontSize: '24px',
                cursor: 'pointer', color: '#999'
              }}
            >
              ✕
            </button>
          </div>

          <div className="qr-code-container" style={{
            margin: '20px 0',
            padding: '15px',
            backgroundColor: '#f8f9fa',
            borderRadius: '10px',
            border: '2px solid #7B1FA2'
          }}>
            {/* VRAI QR Code */}
            <div className="qr-code-image" style={{
              width: '180px',
              height: '180px',
              margin: '0 auto',
              backgroundColor: '#FFFFFF',
              border: '2px solid #7B1FA2',
              borderRadius: '10px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeData)}&color=7B1FA2&bgcolor=FFFFFF`}
                alt={`QR Code pour ${giftPointsTotal} points`}
                style={{ width: '150px', height: '150px' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div style="text-align: center; padding: 20px; color: #7B1FA2;">
                      <div style="font-size: 24px; margin-bottom: 10px;">🎁</div>
                      <div style="font-weight: bold;">${giftPointsTotal} pts</div>
                      <div style="font-size: 10px; margin-top: 5px;">Code: Kdo${giftPointsTotal}</div>
                    </div>
                  `;
                }}
              />
            </div>

            <div style={{
              marginTop: '15px',
              fontSize: '14px',
              color: '#7B1FA2',
              fontWeight: 'bold'
            }}>
              Code: <strong>Kdo{giftPointsTotal}</strong>
            </div>

            <div style={{
              marginTop: '8px',
              fontSize: '12px',
              color: '#666'
            }}>
              Scannez avec l'application SPINTOSS
            </div>
          </div>

          <div className="points-info" style={{
            backgroundColor: '#F3E5F5',
            padding: '15px',
            borderRadius: '5px',
            marginBottom: '20px',
            border: '1px solid #7B1FA2'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#7B1FA2' }}>🎯 Détail des Points</h4>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <span style={{ fontWeight: 'bold' }}>Points totaux:</span>
              <span style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#7B1FA2'
              }}>
                {giftPointsTotal}
              </span>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '14px',
              marginBottom: '5px'
            }}>
              <span>Code:</span>
              <span style={{ fontWeight: 'bold', color: '#7B1FA2' }}>Kdo{giftPointsTotal}</span>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '14px',
              marginBottom: '5px'
            }}>
              <span>Facture:</span>
              <span>{nextBillNumber}</span>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '14px'
            }}>
              <span>{!isFoodTrackMode ? 'Table:' : 'Mode:'}</span>
              <span>{!isFoodTrackMode ? tableNumber : 'Vente Directe'}</span>
            </div>
          </div>

          {giftPointsDetails.length > 0 && (
            <div className="points-details" style={{
              maxHeight: '150px',
              overflowY: 'auto',
              marginBottom: '20px',
              textAlign: 'left',
              backgroundColor: '#f8f9fa',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #dee2e6'
            }}>
              <h5 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '14px' }}>
                📋 Détail par article:
              </h5>
              {giftPointsDetails.map((detail, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '5px',
                  borderBottom: '1px solid #eee',
                  fontSize: '12px'
                }}>
                  <span style={{ flex: 2 }}>{detail.name} x{detail.quantity}</span>
                  <span style={{
                    flex: 1,
                    textAlign: 'right',
                    color: '#7B1FA2',
                    fontWeight: 'bold'
                  }}>
                    {detail.totalPoints} pts
                  </span>
                </div>
              ))}
            </div>
          )}

          <div className="modal-actions" style={{
            display: 'flex',
            gap: '10px'
          }}>
            <button
              onClick={() => {
                // Créer le contenu à imprimer
                const printContent = `
                  <div style="font-family: Arial, sans-serif; text-align: center; max-width: 300px; margin: 0 auto;">
                    <div style="text-align: center; margin-bottom: 15px;">
                      <h2 style="color: #7B1FA2; margin: 0;">🎁 SPINTOSS</h2>
                      <h3 style="color: #333; margin: 5px 0;">QR Code Points Cadeaux</h3>
                    </div>
                    
                    <div style="margin: 20px 0; padding: 15px; background: #f8f9fa; border: 2px solid #7B1FA2; border-radius: 10px;">
                      <!-- QR Code sera généré par le navigateur -->
                      <div id="qrcode" style="width: 180px; height: 180px; margin: 0 auto; background: white; padding: 10px;"></div>
                      <div style="margin-top: 15px; font-size: 14px; color: #7B1FA2; font-weight: bold;">
                        Code: <strong>Kdo${giftPointsTotal}</strong>
                      </div>
                      <div style="margin-top: 5px; font-size: 12px; color: #666;">
                        Scannez pour récupérer ${giftPointsTotal} points
                      </div>
                    </div>
                    
                    <div style="margin-top: 20px; padding: 10px; background: #F3E5F5; border-radius: 5px;">
                      <h4 style="margin: 0 0 10px 0; color: #7B1FA2;">Détail</h4>
                      <div style="display: flex; justify-content: space-between; margin: 5px 0;">
                        <span>Points:</span>
                        <span style="font-weight: bold;">${giftPointsTotal}</span>
                      </div>
                      <div style="display: flex; justify-content: space-between; margin: 5px 0;">
                        <span>Facture:</span>
                        <span>${nextBillNumber}</span>
                      </div>
                      <div style="display: flex; justify-content: space-between; margin: 5px 0;">
                        <span>${!isFoodTrackMode ? 'Table:' : 'Mode:'}</span>
                        <span>${!isFoodTrackMode ? tableNumber : 'Vente Directe'}</span>
                      </div>
                      <div style="display: flex; justify-content: space-between; margin: 5px 0;">
                        <span>Date:</span>
                        <span>${new Date().toLocaleDateString()}</span>
                      </div>
                    </div>
                    
                    <div style="margin-top: 20px; font-size: 10px; color: #999;">
                      SPINTOSS - Merci pour votre visite
                    </div>
                  </div>
                  
                  <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>
                  <script>
                    // Générer le QR Code pour l'impression
                    new QRCode(document.getElementById("qrcode"), {
                      text: '${qrCodeData.replace(/'/g, "\\'")}',
                      width: 180,
                      height: 180,
                      colorDark: "#7B1FA2",
                      colorLight: "#FFFFFF",
                      correctLevel: QRCode.CorrectLevel.H
                    });
                  </script>
                `;

                const printWindow = window.open('', '', 'width=350,height=600,left=100,top=100');
                printWindow.document.write(`
                  <html>
                    <head>
                      <title>QR Code Points - Facture ${nextBillNumber}</title>
                      <style>
                        @media print {
                          body { margin: 0; padding: 10px; }
                          @page { size: auto; margin: 5mm; }
                        }
                      </style>
                    </head>
                    <body>
                      ${printContent}
                      <script>
                        window.onload = function() {
                          // Petite pause pour que le QR Code se génère
                          setTimeout(function() {
                            window.print();
                            setTimeout(function() {
                              window.close();
                            }, 500);
                          }, 300);
                        };
                      </script>
                    </body>
                  </html>
                `);
                printWindow.document.close();
              }}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              📄 Imprimer
            </button>

            <button
              onClick={() => setShowQRCodeModal(false)}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: '#7B1FA2',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    );
  };

  // POPUP DES TABLES (seulement si activé)
  const renderTablesPopup = () => (
    showTablesPopup && isTableSystemEnabled() && (
      <div className="modal-overlay">
        <div className="modal-content large-modal">
          <div className="modal-header">
            <h2>Gestion des Tables - {currentUser?.localisation?.name || "Localisation"}</h2>
            <button
              className="close-modal"
              onClick={() => setShowTablesPopup(false)}
            >
              ✕
            </button>
          </div>

          <div className="modal-body">
            {/* Afficher le total général */}
            <div className="tables-summary" style={{
              backgroundColor: '#f8f9fa',
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '15px',
              border: '1px solid #dee2e6',
              textAlign: 'center'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                <span style={{ fontWeight: 'bold' }}>Nombre de tables:</span>
                <span style={{ color: '#007bff', fontWeight: 'bold' }}>{filteredPendingTables.length}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 'bold' }}>Montant total:</span>
                <span style={{ color: '#28a745', fontWeight: 'bold', fontSize: '18px' }}>
                  {calculateTotalPendingTables()} DT
                </span>
              </div>
            </div>

            <div className="pending-tables-grid">
              {filteredPendingTables && filteredPendingTables.length > 0 ? (
                filteredPendingTables.map((table) => (
                  <div key={table.tableNumber} className="table-button-container">
                    <button
                      onClick={() => {
                        switchTable(table.tableNumber);
                        setShowTablesPopup(false);
                      }}
                      className={`table-button ${tableNumber === table.tableNumber ? "selected" : ""
                        }`}
                      style={{
                        position: 'relative',
                        padding: '15px 10px',
                        textAlign: 'center'
                      }}
                    >
                      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Table {table.tableNumber}
                      </div>
                      <div className="item-count" style={{
                        fontSize: '12px',
                        margin: '5px 0'
                      }}>
                        ({table.items?.length || 0} article{table.items?.length !== 1 ? 's' : ''})
                      </div>
                      <div style={{
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#28a745',
                        marginTop: '5px'
                      }}>
                        {calculateTableTotal(table)} DT
                      </div>
                      {table.createdAt && (
                        <div style={{
                          fontSize: '10px',
                          color: '#666',
                          marginTop: '5px'
                        }}>
                          {new Date(table.createdAt).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </div>
                      )}
                    </button>
                    {config?.features?.tableSystem?.allowTableTransfer && (
                      <button
                        onClick={() => openTransferModal(table.tableNumber)}
                        className="transfer-table-button"
                        title="Transférer cette table"
                      >
                        🔄
                      </button>
                    )}
                  </div>
                ))
              ) : (
                <p className="no-tables">Aucune table en attente dans votre localisation</p>
              )}
            </div>
          </div>

          <div className="modal-actions">
            <button
              className="cancel-button"
              onClick={() => setShowTablesPopup(false)}
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    )
  );

  // POPUP DE SÉLECTION DE TABLE (seulement si activé)
  const renderTableSelectionPopup = () => (
    showTableSelectionPopup && isTableSystemEnabled() && (
      <div className="modal-overlay">
        <div className="modal-content large-modal">
          <div className="modal-header">
            <h2>Sélectionner une Table - {currentUser?.localisation?.name || "Localisation"}</h2>
            <button
              className="close-modal"
              onClick={() => setShowTableSelectionPopup(false)}
            >
              ✕
            </button>
          </div>

          <div className="modal-body">
            {/* Créer une liste de tables libres triée par numéro */}
            {(() => {
              // Créer un tableau de toutes les tables possibles
              const maxTables = config?.features?.tableSystem?.maxTables || 50;
              const occupiedTables = filteredPendingTables.map(t => t.tableNumber);

              // Créer un tableau de tables libres
              const freeTables = [];
              for (let i = 1; i <= maxTables; i++) {
                const tableNum = i.toString();
                if (!occupiedTables.includes(tableNum)) {
                  freeTables.push(tableNum);
                }
              }

              // Trier les tables libres par numéro
              freeTables.sort((a, b) => parseInt(a) - parseInt(b));

              return (
                <div className="pending-tables-grid">
                  {freeTables.length > 0 ? (
                    freeTables.map((tableNum) => (
                      <div key={tableNum} className="table-button-container">
                        <button
                          onClick={() => {
                            handleTableNumberInput(tableNum);
                            setShowTableSelectionPopup(false);
                          }}
                          className={`table-button`}
                          style={{
                            backgroundColor: '#28a745',
                            color: 'white'
                          }}
                        >
                          Table {tableNum}
                          <span className="item-count" style={{ color: '#e0e0e0' }}>
                            Libre
                          </span>
                        </button>
                      </div>
                    ))
                  ) : (
                    <p className="no-tables">Toutes les tables sont occupées</p>
                  )}
                </div>
              );
            })()}
          </div>

          <div className="modal-actions">
            <button
              className="cancel-button"
              onClick={() => setShowTableSelectionPopup(false)}
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    )
  );

  // POPUP DE TRANSFERT
  const renderTransferModal = () => (
    showTransferModal && tableToTransfer && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Transfert de Table</h3>
            <button
              className="close-modal"
              onClick={() => {
                setShowTransferModal(false);
                setTableToTransfer(null);
                setTransferTargetTable("");
              }}
            >
              ✕
            </button>
          </div>

          <div className="transfer-info">
            <p>Transfert de la <strong>Table {tableToTransfer.tableNumber}</strong></p>
            <p>Nombre d'articles: {tableToTransfer.items?.length || 0}</p>
            <p>Localisation: {tableToTransfer.location?.name || currentUser?.localisation?.name || "Non définie"}</p>
          </div>

          <div className="transfer-form">
            <label>Nouvelle table :</label>
            <select
              value={transferTargetTable}
              onChange={(e) => setTransferTargetTable(e.target.value)}
              className="table-select"
            >
              <option value="">Sélectionner une table</option>
              {[...Array(config?.features?.tableSystem?.maxTables || 50)].map((_, i) => {
                const num = (i + 1).toString();
                const isOccupied = filteredPendingTables.find(t => t.tableNumber === num);
                return !isOccupied ? (
                  <option key={num} value={num}>
                    Table {num}
                  </option>
                ) : null;
              })}
            </select>
          </div>

          <div className="modal-actions">
            <button
              onClick={executeTableTransfer}
              disabled={!transferTargetTable}
              className="confirm-button"
            >
              Confirmer le Transfert
            </button>
            <button
              onClick={() => {
                setShowTransferModal(false);
                setTableToTransfer(null);
                setTransferTargetTable("");
              }}
              className="cancel-button"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    )
  );

  // POPUP DE PAIEMENT PARTIEL
  const renderPartialPaymentModal = () => (
    showPartialPayment && (
      <div className="modal-overlay">
        <div className="modal-content large-modal">
          <div className="modal-header">
            <h3>Paiement Partiel</h3>
            <button
              className="close-modal"
              onClick={() => {
                setShowPartialPayment(false);
                setSelectedPartialItems([]);
                setPartialQuantities({});
              }}
            >
              ✕
            </button>
          </div>

          <div className="modal-body">
            <p>Sélectionnez les articles à payer partiellement :</p>
            <table className="addition-table">
              <thead>
                <tr>
                  <th>Sélection</th>
                  <th>Nom</th>
                  <th>Quantité Disponible</th>
                  <th>Quantité à Payer</th>
                  <th>Prix Unitaire</th>
                  <th>Total</th>
                  <th>Points</th>
                </tr>
              </thead>
              <tbody>
                {additionItems.map((item) => {
                  const itemPoints = getSubProductPoints(item.id);

                  return (
                    <tr key={item.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedPartialItems.includes(item.id)}
                          onChange={() => togglePartialItem(item.id)}
                        />
                      </td>
                      <td>{item.name}</td>
                      <td>{item.quantity}</td>
                      <td>
                        {selectedPartialItems.includes(item.id) && (
                          <input
                            type="number"
                            value={getPartialQuantity(item.id)}
                            onChange={(e) => modifyPartialQuantity(item.id, parseInt(e.target.value) || 0)}
                            style={{ width: "60px" }}
                            min="0"
                            max={item.quantity}
                          />
                        )}
                      </td>
                      <td>{item.price.toFixed(2)} DT</td>
                      <td>
                        {selectedPartialItems.includes(item.id) ?
                          (item.price * getPartialQuantity(item.id)).toFixed(2) + " DT" :
                          "0.00 DT"
                        }
                      </td>
                      <td style={{ color: '#9C27B0', fontWeight: 'bold' }}>
                        {itemPoints * (selectedPartialItems.includes(item.id) ? getPartialQuantity(item.id) : 0)} pts
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="partial-total">
              <h4>Total partiel : {calculatePartialTotal()} DT</h4>
              {selectedPartialItems.length > 0 && (
                <div style={{ color: '#7B1FA2', marginTop: '5px' }}>
                  Points cadeaux partiels : {calculateGiftPointsForPartial(
                    additionItems.filter(item => selectedPartialItems.includes(item.id)).map(item => ({
                      ...item,
                      quantity: getPartialQuantity(item.id)
                    }))
                  )} points
                </div>
              )}
            </div>

            <div className="payment-section">
              <h4>Mode de paiement :</h4>
              {renderPaymentMethods()}
            </div>

            <div className="modal-actions">
              <button
                onClick={confirmPartialPayment}
                className="confirm-addition-button"
                disabled={selectedPartialItems.length === 0}
              >
                Confirmer Paiement Partiel
              </button>
              <button
                onClick={() => {
                  setShowPartialPayment(false);
                  setSelectedPartialItems([]);
                  setPartialQuantities({});
                }}
                className="cancel-button"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );

  // MODAL D'ANNULATION D'ARTICLE
  const renderCancelModal = () => (
    showCancelModal && (
      <div className="modal-overlay" style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center',
        alignItems: 'center', zIndex: 2000
      }}>
        <div className="modal-content" style={{
          backgroundColor: 'white', padding: '20px', borderRadius: '8px',
          maxWidth: '500px', width: '90%', maxHeight: '90vh', overflowY: 'auto'
        }}>
          <h3>Annulation d'Article</h3>

          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label>Date de la facture (YYYY-MM-DD):</label>
            <input
              type="date"
              value={invoiceDate}
              onChange={(e) => setInvoiceDate(e.target.value)}
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label>Numéro de Facture:</label>
            <input
              type="text"
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
              placeholder="Ex: 001, 002, etc."
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>

          <button
            onClick={searchBill}
            disabled={searchLoading || !invoiceDate || !invoiceNumber}
            style={{
              backgroundColor: '#17a2b8', color: 'white', border: 'none',
              padding: '8px 15px', borderRadius: '4px', cursor: 'pointer',
              marginBottom: '15px', width: '100%'
            }}
          >
            {searchLoading ? "Recherche..." : "Rechercher la Facture"}
          </button>

          {foundBill && (
            <div style={{
              backgroundColor: '#d4edda', padding: '10px', borderRadius: '4px',
              marginBottom: '15px', border: '1px solid #c3e6cb'
            }}>
              <strong>Facture trouvée:</strong><br />
              N°: {foundBill.billNumber} |
              Date: {new Date(foundBill.date).toLocaleDateString()} |
              Total: {foundBill.total} DT
            </div>
          )}

          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label>Code Administrateur:</label>
            <input
              type="password"
              value={adminCode}
              onChange={(e) => setAdminCode(e.target.value)}
              placeholder="Entrez le code admin"
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>

          {foundBill && (
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label>Sélectionnez l'article à annuler:</label>
              <select
                value={cancelBarcodeInput}
                onChange={(e) => setCancelBarcodeInput(e.target.value)}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              >
                <option value="">Choisissez un article</option>
                {foundBill.items.map((item, index) => (
                  <option key={index} value={item._id}>
                    {item.name} - {item.price} DT x {item.quantity}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label>Motif d'annulation:</label>
            <select
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            >
              <option value="">Sélectionnez un motif</option>
              <option value="retour_produit">Retour produit défectueux</option>
              <option value="changement_produit">Changement de produit</option>
              <option value="erreur_commande">Erreur de commande</option>
              <option value="client_insatisfait">Client insatisfait</option>
              <option value="autre">Autre raison</option>
            </select>
          </div>

          <div className="modal-buttons" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
            <button
              onClick={cancelArticle}
              disabled={!adminCode || !cancelBarcodeInput || !cancelReason || !foundBill || loading}
              className="confirm-button"
              style={{
                backgroundColor: '#28a745', color: 'white', border: 'none',
                padding: '10px 15px', borderRadius: '5px', cursor: 'pointer'
              }}
            >
              {loading ? "Traitement..." : "Confirmer l'annulation"}
            </button>
            <button
              onClick={() => {
                setShowCancelModal(false);
                setFoundBill(null);
                setInvoiceDate("");
                setInvoiceNumber("");
                setCancelBarcodeInput("");
                setCancelReason("");
                setAdminCode("");
              }}
              className="cancel-button"
              style={{
                backgroundColor: '#6c757d', color: 'white', border: 'none',
                padding: '10px 15px', borderRadius: '5px', cursor: 'pointer'
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    )
  );

  // ========================================
  // AJOUTER UN BOUTON POUR OUVRIR LE POPUP D'AJOUT DE POINTS
  // ========================================
  const renderAddPointsButton = () => (
    <button
      onClick={() => setShowPointsPopup(true)}
      className="add-points-button"
      style={{
        backgroundColor: '#7B1FA2',
        color: 'white',
        border: 'none',
        padding: '10px 15px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginLeft: '-1px'
      }}
      title="Ajouter des points cadeaux au client par numéro de téléphone"
    >
      🎁 Ajouter Les Points
    </button>
  );

  // ========================================
  // MODIFIER LA SECTION DES BOUTONS D'ACTION POUR AJOUTER LE BOUTON
  // ========================================
  const renderActionButtons = () => (
    <div className="confirm-buttons">
      {/* Bouton Ajouter Points */}
      {renderAddPointsButton()}

      <button
        onClick={printAdditionDirect}
        disabled={additionItems.length === 0 || (!isFoodTrackMode && !tableNumber)}
        className="print-addition-button"
        style={{
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold'
        }}
        title="Imprimer l'addition actuelle"
      >
        🖨️ Addition
      </button>


      {/* Bouton Payer */}
      <button
        onClick={handleDirectPayment}
        disabled={additionItems.length === 0}
        className="confirm-addition-button"
        style={{
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold'
        }}
      >
        {isFoodTrackMode ? "Payer Directement" : "Payer"}
      </button>

      {/* Bouton Paiement Combiné */}
      <button
        onClick={openCombinedPaymentModal}
        disabled={additionItems.length === 0 || (!isFoodTrackMode && !tableNumber)}
        className="combined-payment-button"
        style={{
          backgroundColor: '#9c27b0',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold'
        }}
      >
        Paiement Combiné
      </button>

      {/* Bouton Paiement Partiel */}
      {config?.features?.payment?.allowPartialPayment && (
        <button
          onClick={() => setShowPartialPayment(true)}
          disabled={additionItems.length === 0 || (!isFoodTrackMode && !tableNumber)}
          className="partial-payment-button"
          style={{
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          Paiement Partiel
        </button>
      )}

      {/* Bouton Addition Personnel */}
      {canAccessStaffAddition() && (
        !isStaffAddition ? (
          <button
            onClick={activateStaffAddition}
            disabled={additionItems.length === 0 || (!isFoodTrackMode && !tableNumber) || filteredStaffList.length === 0}
            className="staff-addition-button"
            style={{
              backgroundColor: '#ff5722',
              color: 'white',
              border: 'none',
              padding: '8px 15px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
            title={filteredStaffList.length === 0 ? "Aucun employé disponible" : ""}
          >
            Addition Personnel
            {filteredStaffList.length > 0 && ` (${filteredStaffList.length})`}
          </button>
        ) : (
          <button
            onClick={resetStaffAddition}
            className="staff-addition-button"
            style={{
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              padding: '8px 15px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            Annuler Addition Personnel
          </button>
        )
      )}

      {/* Bouton pour afficher le QR Code des points cadeaux */}
      {giftPointsTotal > 0 && (
        <button
          onClick={openQRCodeModal}
          className="qrcode-points-button"
          style={{
            backgroundColor: '#7B1FA2',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            marginLeft: '10px'
          }}
        >
          🎁 QR Code Points
        </button>
      )}
    </div>
  );

  // Afficher l'information de l'addition personnel dans l'interface
  const renderAdditionHeader = () => (
    <div className="addition-header">
      <h3>
        {isFoodTrackMode ? "VENTE DIRECTE" : `Addition - Table ${tableNumber || "Non sélectionnée"}`} - {currentUser?.localisation?.name || "Localisation"}
        {isStaffAddition && (
          <span style={{
            color: '#ff9800',
            fontSize: '16px',
            marginLeft: '10px',
            backgroundColor: '#fff3e0',
            padding: '2px 8px',
            borderRadius: '4px',
            border: '1px solid #ff9800'
          }}>
            PERSONNEL -{config?.features?.staff?.discountPercentage || 20}%
          </span>
        )}
        {giftPointsTotal > 0 && (
          <span style={{
            color: '#7B1FA2',
            fontSize: '16px',
            marginLeft: '10px',
            backgroundColor: '#F3E5F5',
            padding: '2px 8px',
            borderRadius: '4px',
            border: '1px solid #7B1FA2'
          }}>
            🎁 {giftPointsTotal} points
          </span>
        )}
      </h3>
    </div>
  );

  if (!currentUser) {
    return <div className="loading">Chargement des données utilisateur...</div>;
  }

  // MODAL POUR AJOUTER DES POINTS PAR TÉLÉPHONE
  const renderPointsPopup = () => (
    showPointsPopup && (
      <div className="modal-overlay" style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center',
        alignItems: 'center', zIndex: 3000
      }}>
        <div className="modal-content" style={{
          backgroundColor: '#fff', padding: '25px', borderRadius: '15px',
          width: '400px', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
        }}>
          <h2 style={{ color: '#7B1FA2', marginBottom: '10px' }}>🎁 Ajouter Les Points</h2>
          <div style={{
            backgroundColor: '#F3E5F5', padding: '15px', borderRadius: '10px',
            marginBottom: '20px', border: '1px solid #CE93D8'
          }}>
            <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0 }}>
              Points à ajouter: <span style={{ color: '#7B1FA2' }}>{giftPointsTotal} pts</span>
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ marginBottom: '10px', fontWeight: '500' }}>Numéro de téléphone du client:</p>
            <div style={{
              fontSize: '24px', letterSpacing: '2px', backgroundColor: '#f5f5f5',
              padding: '12px', borderRadius: '8px', border: '2px solid #ddd',
              height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              {clientPhone || <span style={{ color: '#aaa' }}>Saisir 8 chiffres</span>}
            </div>

            {/* Affichage du nom du client vérifié */}
            {clientName && (
              <div style={{
                marginTop: '10px',
                padding: '10px',
                backgroundColor: '#E8F5E9',
                border: '2px solid #4CAF50',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}>
                <span style={{ fontSize: '20px' }}>✅</span>
                <span style={{ color: '#2E7D32', fontWeight: 'bold', fontSize: '16px' }}>
                  {clientName}
                </span>
              </div>
            )}
          </div>

          {/* CLAVIER NUMÉRIQUE */}
          <div className="numpad" style={{
            display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px',
            marginBottom: '20px'
          }}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, "0", "DEL"].map((key) => (
              <button
                key={key}
                onClick={() => handlePhoneInput(key.toString())}
                style={{
                  padding: '15px', fontSize: '18px', fontWeight: 'bold',
                  borderRadius: '8px', border: '1px solid #ccc',
                  backgroundColor: key === "DEL" ? "#ffc107" : "#fff",
                  cursor: 'pointer'
                }}
              >
                {key}
              </button>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={handleLinkPhoneToOrder}
              disabled={clientPhone.length < 8}
              style={{
                flex: 2, padding: '15px', backgroundColor: '#7B1FA2',
                color: 'white', border: 'none', borderRadius: '8px',
                fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
                opacity: clientPhone.length < 8 ? 0.6 : 1
              }}
            >
              Lier Mon Numéro
            </button>
            <button
              onClick={() => { setShowPointsPopup(false); setClientPhone(""); setClientName(""); }}
              style={{
                flex: 1, padding: '15px', backgroundColor: '#dc3545',
                color: 'white', border: 'none', borderRadius: '8px',
                fontSize: '16px', fontWeight: 'bold', cursor: 'pointer'
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    )
  );

  return (
    <div className="menu-container">
      {/* Bandeau d'information */}
      <div style={{
        position: 'fixed',
        top: '10px',
        left: '10px',
        backgroundColor: isFoodTrackMode ? '#ff9800' : '#007bff',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '5px',
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: 1000
      }}>
        {isFoodTrackMode ? '🍔 FOODTRACK' : '🍽️ RESTAURANT'} - Facture N°: {nextBillNumber}
        {isStaffAddition && (
          <span style={{ marginLeft: '10px', backgroundColor: '#ff9800', padding: '2px 6px', borderRadius: '3px' }}>
            👥
          </span>
        )}
        {giftPointsTotal > 0 && (
          <span style={{ marginLeft: '10px', backgroundColor: '#7B1FA2', padding: '2px 6px', borderRadius: '3px' }}>
            🎁 {giftPointsTotal} pts
          </span>
        )}
        {clientPhone && clientPhone.length >= 8 && (
          <span style={{ marginLeft: '10px', backgroundColor: '#28a745', padding: '2px 6px', borderRadius: '3px' }}>
            📱 {clientPhone}
          </span>
        )}
      </div>

      {/* Auto-rafraîchissement (seulement si tables activées) */}
      {isTableSystemEnabled() && (
        <div style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          backgroundColor: '#28a745',
          color: 'white',
          padding: '5px 10px',
          borderRadius: '5px',
          fontSize: '12px',
          zIndex: 1000
        }}>
          Auto-rafraîchi
        </div>
      )}

      <div className="menu-section">
        {shouldShowSection('categoriesSection') && renderCategoryButtons()}
        {shouldShowSection('productsSection') && renderProducts()}
      </div>

      <div className="addition-section">
        {shouldShowSection('additionSection') && (
          <>
            {renderAdditionHeader()}

            {additionItems.length === 0 ? (
              <p className="no-items">Aucun article sélectionné.</p>
            ) : (
              <>
                {renderAdditionTable()}

                {shouldShowSection('discountSection') && (
                  <div className="discount-section">
                    {!isStaffAddition ? (
                      <>
                        <div className="discount-buttons">
                          <button onClick={apply10PercentCardDiscount}>
                            Remise 10% Carte
                          </button>
                          <button onClick={() => setDiscount(20)}>
                            Remise 20%
                          </button>
                        </div>
                      </>
                    ) : (
                      <div style={{
                        backgroundColor: '#e8f5e8',
                        padding: '10px',
                        borderRadius: '5px',
                        textAlign: 'center',
                        border: '1px solid #4caf50'
                      }}>
                        <strong>ADDITION PERSONNEL</strong><br />
                        Réduction de {config?.features?.staff?.discountPercentage || 20}% appliquée sur tous les articles
                        {selectedStaff && (
                          <div style={{ marginTop: '5px', fontSize: '14px' }}>
                            Pour: {staffList.find(s => s._id === selectedStaff)?.name} - {staffList.find(s => s._id === selectedStaff)?.matricule || staffList.find(s => s._id === selectedStaff)?.employeeId || staffList.find(s => s._id === selectedStaff)?.code || 'N/A'}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {renderActionButtons()}
              </>
            )}
          </>
        )}
      </div>

      {/* SECTION TABLES (seulement si activée) */}
      {shouldShowSection('tablesSection') && isTableSystemEnabled() && (
        <div className="tables-section">
          <div className="table-selection-card">
            <h3 className="section-title">
              Sélection de Table - {currentUser?.localisation?.name || "Localisation"}
              <span style={{
                fontSize: '12px',
                color: '#6c757d',
                marginLeft: '10px',
                fontWeight: 'normal'
              }}>

              </span>
            </h3>

            <div className="table-input-group">
              <div className="table-display">
                <span className="table-label">Table actuelle:</span>
                <span className="table-number">{tableNumber || ""}</span>
              </div>

              {shouldShowElement('tableSelectionPopup') && (
                <button
                  className="table-dropdown"
                  onClick={() => setShowTableSelectionPopup(true)}
                >
                  Choisir une Table
                </button>
              )}

              <button
                className="clear-table-btn"
                onClick={() => handleTableNumberInput("DEL")}
                disabled={!tableNumber}
              >
                Effacer Table
              </button>
            </div>

            {shouldShowElement('pendingTablesButton') && (
              <div className="tables-popup-button-container">
                <button
                  className="open-tables-popup"
                  onClick={() => setShowTablesPopup(true)}
                >
                  <div>Gérer les Tables ({filteredPendingTables.length})</div>
                  <span style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 'bolder',
                    marginTop: '2px',
                    color: '#f9a704ff'
                  }}>
                    Total: {calculateTotalPendingTables()} DT
                  </span>
                </button>
              </div>
            )}

            <div className="quick-actions">
              {shouldShowElement('lockTableButton') && (
                <button
                  className="open-tables-popup"
                  onClick={lockTable}
                  disabled={!tableNumber || additionItems.length === 0}
                >
                  Verrouiller Table
                </button>
              )}
            </div>

            {/* BOUTON ANNULER ARTICLE - exactement comme dans le premier code */}
            <div>
              <button
                onClick={openCancelModal}
                className="global-cancel-button"
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  padding: '13px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                Annuler Article
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODALS */}
      {renderPaymentModal()}
      {renderCombinedPaymentModal()}
      {renderQRCodeModal()}
      {renderQRScannerModal()}
      {renderTableSelectionPopup()}
      {renderTablesPopup()}
      {renderTransferModal()}
      {renderPartialPaymentModal()}
      {renderCancelModal()}
      {renderStaffModal()}
      {renderPointsPopup()}

      {/* Indicateur de mode */}
      {isFoodTrackMode && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          backgroundColor: '#ff9800',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: 'bold',
          zIndex: 1000,
          boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
        }}>
          🍔 MODE FOODTRACK - VENTE DIRECTE
        </div>
      )}
    </div>
  );
}

export default Menu;